import { useSelector } from "react-redux";
import { Routes, Route, Navigate, RoutesProps } from "react-router-dom";
import { RootState } from "../config/Store";
import Main from "../Main";
import UpdateRiskProfile from "../pages/UpdateRiskProfile";
import { UserState } from "../reducers/AuthReducer";
import Loader from "../components/Loader/Loader";
import React from "react";
import { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Goals from "../screens/DataEntryOperator/Goals/Goals";
import Documents from "../screens/Documents/Documents";
import InvestorCharter from "../screens/Admin/Masters/WebsiteCompliance/InvestorCharter";
import Complaints from "../screens/Admin/Masters/WebsiteCompliance/Complaints";
import ComplaintsCount from "../screens/Admin/Masters/WebsiteCompliance/ComplaintsCount";
import AddComplaints from "../screens/Admin/Masters/WebsiteCompliance/AddComplaints";
import FixedReturnandRetirementProducts from "../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturnandRetirementProducts/FixedReturnandRetirementProducts";
import AddFixedReturnandRetirementProducts from "../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturnandRetirementProducts/AddFixedReturnandRetirementProducts";
import ArchivedFixedReturnandRetirementProducts from "../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturnandRetirementProducts/ArchivedFixedReturnandRetirementProducts";
import Agreement from "../screens/Admin/MisReport/Agreement/Agreement";
import AddAgreement from "../screens/Admin/MisReport/Agreement/AddAgreement";
import ArchivedAgreement from "../screens/Admin/MisReport/Agreement/ArchivedAgreement";
import AgreementUploadDocument from "../screens/Admin/MisReport/Agreement/AgreementUploadDocument";
import AgreementReport from "../screens/SuperAdmin/MisReport/AgreementReport";







const lazyRetry = function (componentImport: any) {
  return new Promise<any>((resolve, reject) => {
    componentImport().then((component: any) => {
      resolve(component);
    }).catch((error: any) => {
      reject(error); // there was an error
    });
  });
};

const SmallCaseSdkBlankPage = React.lazy(() => lazyRetry(() => import("../components/SpringMoney/Transactions/SmallCaseSdkBlankPage")));
const Login = React.lazy(() => lazyRetry(() => import("../screens/Login/Login")));
const ForgetPassword = React.lazy(() => import("../screens/Login/ForgetPassword/ForgetPassword"));
const SetPassword = React.lazy(() => import("../screens/Login/SetPassword"));

const Alerts = React.lazy(() => import("../screens/DataEntryOperator/Alerts"));
const MyProfile = React.lazy(() => import("../screens/DataEntryOperator/MyProfile"));
const ChangePassword = React.lazy(() => import("../screens/DataEntryOperator/ChangePassword"))
// Step Wizard

const Otp = React.lazy(() => import("../screens/Login/Otp"));
const Welcome = React.lazy(() => import("../screens/NewRegistration/Welcome"));
const SelfInfo = React.lazy(() => import("../screens/NewRegistration/SelfInfo"));
const SpouseInfo = React.lazy(() => import("../screens/NewRegistration/SpouseInfo"));
const Members = React.lazy(() => import("../screens/NewRegistration/Members"));
const AddMember = React.lazy(() => import("../screens/NewRegistration/AddMember"));
const MembersList = React.lazy(() => import("../screens/NewRegistration/MembersList"));

// DATA ENTRY OPERATOR
const Review = React.lazy(() => import("../screens/DataEntryOperator/Review/Review"));
const ReviewArchived = React.lazy(() => import("../screens/DataEntryOperator/Review/ReviewArchived"));
const ReviewDetails = React.lazy(() => import("../screens/DataEntryOperator/Review/ReviewDetails"));

// 1) Dashboard Module
const DashBoard = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/Dashboard"));
const NewRiskProfile = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfile"));
const NewRiskProfileQue = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileQue"));
const NewRiskProfileQueManual = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileQueManual"));
const NewRiskProfileQueSystem = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileQueSystem"));
const NewRiskProfileDeclaimer = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileDeclaimer"));
const NewRiskProfileOverride = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileOverride"));
const OverrideDisclaimer = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/RiskProfile/OverrideResult"));
const RiskProfilHistory = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/RiskProfile/RiskProfileHistory"));
//Establisment Menu
const Establishment = React.lazy(() => import("../screens/DataEntryOperator/Information/Establishment/AddEstablishmentDetails"));

// 2) Information Module
const Family = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/Family"));
const EditFamilyMember = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/EditFamilyMember"));
const AddFamilyMember = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddFamilyMember"));
const ArchivedFamily = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/ArchivedFamily"));

const AddBankAccount = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AddBankAccount"));
const AddDmatAccount = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AddDmatAccount"));
const AddMfCard = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AddMfCard"));
const AccountMandates = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AccountMandates/AccountMandates"));
const AddAccountMandates = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AccountMandates/AddAccountMandates"))
const ArchivedAccountMandates = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AccountMandates/ArchivedAccountMandates"));
const BankAccounts = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/BankAccounts"));
const Income = React.lazy(() => import("../screens/DataEntryOperator/Information/Income/Income"));
const AddIncome = React.lazy(() => import("../screens/DataEntryOperator/Information/Income/AddIncome"));
const IncomeArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/Income/ArchivedIncome"));

const Loans = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/Loans"));
const AddLoan = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/AddLoan"));
const LoansArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/LoansArchived"));
const LoansAmortization = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/LoansAmortization"));
const ImportAmotizationLoan = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/ImportAmotiztionLoan"));

const Address = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/Address"));
const AddAddress = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddAddress"));
const AddressArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddressArchivedList"));

const PhysicalAssetHousehold = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsHousehold/PhysicalAssetsHousehold"));
const AddPhysicalAssetsHousehold = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsHousehold/AddPhysicalAssetsHousehold"));
const PhysicalAssetHouseholdArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetHouseholdArchivedList"));
const MultipleAddHouseHold = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsHousehold/MultipleAddHouseHold"));

const HealthLifestyle = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/HealthLifestyle"));
const AddHealthLifestyle = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddHealthLifestyle"));

const Occupation = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/Occupation"));
const EditOccupation = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/EditOccupation"));
const OccupationArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/OccupationArchived"));

const Insurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/Insurance"));
const AddInsurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/AddInsurance"));
const InsuranceRiders = React.lazy(() => import("../screens/DataEntryOperator/Insurance/InsuranceRiders"));
const ArchivedInsurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/ArchivedInsurance"));
const FutureInsurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/FutureInsurance"));
const AddMoneyBackPayout = React.lazy(() => import("../screens/DataEntryOperator/Insurance/AddMoneyBackPayout"));

const Vehicles = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetsVehicles"));
const PhysicalAssetsVehicle = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetsVehicles"));
const AddPhysicalAssetsVehicle = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/AddPhysicalAssetsVehicles"));
const PhysicalAssetsVehicleArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetVehicleArchivedList"));

//Header 

const ArchivedDocument = React.lazy(() => import("../screens/DataEntryOperator/Header/Document/ArchivedDocument"));
const AddDocument = React.lazy(() => import("../screens/DataEntryOperator/Header/Document/AddDocument"));
const MyDocuments = React.lazy(() => import("../screens/DataEntryOperator/Header/Document/MyDocuments"));
const Discrepanices = React.lazy(() => import("../screens/DataEntryOperator/Header/Discrepancies/Discrepancies"));


// 3) Portfolio
const Portfolio = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/Porfolio"));
const PpfAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PpfAccount"));
const AddPpfAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddPpfAccount"));
const PpfArchivedAccounts = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PpfArchivedAccount"));


const AddEpfDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddEpfDetails"));
const AddEpfPassbookEntry = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddEpfPassbookEntry"));
const NpsDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/NpsDetails"));

const AddNpsDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddNpsDetails"));
const NpsDetailArchieved = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/NpsDetailArchived"));
const AddPpfPassbookEntry = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddPpfPassbookEntry"));
const AddSuperannuationDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddSuperannuationDetails"));
const SuperAnnutationArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SuperannutationArchived"));
const BondsAndDebenturesArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BondsAndDebentureArchived"));
const BondsAndDebentures = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BondsAndDebentures"));
const AddBondAndDebentures = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddBondAndDebentures"));
const BullionInvestments = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BullionInvestments"));
const EditBullionInvestments = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EditBullionInvestments"));
const BullionInvestmentsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BullionInvestmentArchived"));
const ArcheivedBullionSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ArcheivedBullionSip"));
const AddBullionSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddBullionSip"));
const CashEquivalents = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/CashEquivalents"));
const EpfAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EpfAccount"));
const EpfArchieved = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EpfArchieved"));
const EpfPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EpfPassbook"));
const AddFixedReturn = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddFixedReturn"));
const FixedReturn = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturn"));
const FixedReturnArchieved = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnArchieved"));
const FixedReturnInterestRecords = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnInterestRecords"));
const FixedReturnInterestRecordsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnIntrestRecordArchived"));
const FixedReturnPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnPassbook"));
const InsurancePortfolio = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/InsurancePortfolio"));

const MutualFunds = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFunds"));
const MutualFundsTransactions = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFundsTransactions"));
const MutualFundsArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFundsArchivedList"));
const MutualFundsTransactionsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFundsTransactionsArchived"));
const SystematicInvestmentArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SystematicInvestmentArchived"));
const AddSipStpSwp = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddSipStpSwp"));

const PpfPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PpfPassbook"));
const RealEstateProperties = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/RealEstateProperties"));
const AddRealEstate = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddRealEstateProperties"));
const RealEstateArchivedAccounts = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/RealEstateArchived"));


const ShareETF = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ShareETF"));
const ShareEtfTransactions = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SahreEtfTransactions"));
const ShareETFHoldingArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ShareETFHoldingArchivedList"));
const ShareEtfTransactionsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SahreEtfTransactionsArchived"));
const ChangeDmat = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ChangeDmat"));
const UpdateShareEtfTransaction = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/UpdateShareEtfTransaction"));
const AddShareEpfSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddShareEpfSip"));
const ArcheivedShareSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ArcheivedSharesSip"));

const SsyAddAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyAddAccount"));
const SsyAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyAccount"));
const SsyArchivedAccounts = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyArchivedAccount"));
const SsyPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyPassbook"));
const AddSsyPassbookEntry = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddSsyPassbookEntry"));
const SsyPassbookArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyPassbookArchived"));


const SuperannuationAcc = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SuperannuationAcc"));
const UpdateMutualFundTransaction = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/UpdateMutualFundTransaction"));

// 4) Goals Module
// const Goals = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/Goals/Goals"));
const AddGoal = React.lazy(() => import("../screens/DataEntryOperator/Goals/AddGoal"));
const ArcheivedGoals = React.lazy(() => import("../screens/DataEntryOperator/Goals/ArcheivedGoals"));

// 5) Expense Module
const Expenses = React.lazy(() => import("../screens/DataEntryOperator/Expenses/Expenses"));
const ExpensesDetails = React.lazy(() => import("../screens/DataEntryOperator/Expenses/ExpensesDetails"));
const ExpensesMinimum = React.lazy(() => import("../screens/DataEntryOperator/Expenses/ExpensesMinimum"));
const ExpensesDetailsSave = React.lazy(() => import("../screens/DataEntryOperator/Expenses/ExpensesDetailsSave"));

// 6) Action
const Actions = React.lazy(() => import("../screens/DataEntryOperator/Action/Actions"));
const AddAction = React.lazy(() => import("../screens/DataEntryOperator/Action/AddAction"));
const MyTask = React.lazy(() => import("../screens/DataEntryOperator/Action/MyTask"));
const ArchivedAssignTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedAssignTask"));
const Recurring = React.lazy(() => import("../screens/DataEntryOperator/Action/Recurring"));
const Hibernated = React.lazy(() => import("../screens/DataEntryOperator/Action/Hibernated"));
const ArchivedMyTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedMyTask"));
const DocumentTracker = React.lazy(() => import("../screens/DataEntryOperator/Action/DocumentTracker"));
const AddDocumentTracker = React.lazy(() => import("../screens/DataEntryOperator/Action/AddDocumentTracker"));
const ArchivedRecurring = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedRecurring"));
const EditTask = React.lazy(() => import("../screens/DataEntryOperator/Action/EditAction"));
const AssignTask = React.lazy(() => import("../screens/DataEntryOperator/Action/AssignTask"));
const Manager = React.lazy(() => import("../screens/DataEntryOperator/Action/Manager"));
const MomSentForReview = React.lazy(() => import("../screens/DataEntryOperator/Action/MomSentForReview"));
const ReassignManager = React.lazy(() => import("../screens/DataEntryOperator/Action/ReassignManager"));
const UnassignedManager = React.lazy(() => import("../screens/DataEntryOperator/Action/UnassignedManager"));
const ReceivedForReview = React.lazy(() => import("../screens/DataEntryOperator/Action/ReceivedForReview"));
const ClientActionTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ClientActionTask"));
const AddRecurring = React.lazy(() => import("../screens/DataEntryOperator/Action/AddRecurring"));
const ArchivedDocumentTracker = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedDocumentTracker"));
const ClientTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ClientTask"));
const RaiseAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/RaiseAdviceRequest"));
const AddClientAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/AddClientAdviceRequest"));
const ArcheivedClientAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/ArcheivedClientAdviceRequest"));
const EditLumSumInvestment = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabLumSumInvestment"));
const EditSipInvestment = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabSipInvestment"));
const EditRedemption = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabRedemption"));
const EditSipCancellation = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabSIPCancellation"));
const EditSipPause = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabSIPPaused"));


//Planing
const LifeInsuranceReq = React.lazy(() => import("../screens/DataEntryOperator/Planing/LifeInsuranceReq"));
const RetirementPlan = React.lazy(() => import("../screens/DataEntryOperator/Planing/RetirementPlan"));
const LifeInsuranceExpenses = React.lazy(() => import("../screens/DataEntryOperator/Planing/LifeInsuranceExpenses"));


// 7) MIS Report
const MisReport = React.lazy(() => import("../screens/DataEntryOperator/Action/MisReport"));
const Reports = React.lazy(() => import("../screens/DataEntryOperator/Reports/Reports"));
const TransactionReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/TransactionReport"));
const CapitalGainReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/CapitalGainReport"));
const NotionalCapitalGainReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/NotionalCapitalGainReport"));
const InvoicesReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/InvoicesReport"));
const Tax = React.lazy(() => import("../screens/DataEntryOperator/Reports/Tax"));
const PaidInvoicesReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/PaidInvoicesReport"));
const TaxCalculationReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/TaxCalculationReport"));
const TaxCalculationReportOldRegim = React.lazy(() => import("../screens/DataEntryOperator/Reports/TaxCalculationReportOldRegim"));
const HoldingReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/HoldingReport"));
const ReportExpectedCashFlow = React.lazy(() => import("../screens/DataEntryOperator/Reports/ReportExpectedFutureCashFlow"));
const ArchivedSubscribedServices = React.lazy(() => import("../screens/Admin/MisReport/ArchivedSubscribedServices"));
const InsuranceRenewal = React.lazy(() => import("../screens/Admin/MisReport/InsuranceRenewal"));
const MaturityInvestments = React.lazy(() => import("../screens/Admin/MisReport/MaturityInvestments"));
const InvestmentAccount = React.lazy(() => import("../screens/Admin/MisReport/InvestmentsAccount"));
const ShareIsin = React.lazy(() => import("../screens/Admin/MisReport/SharesIsin"));
const RiskProfileMisReport = React.lazy(() => import("../screens/Admin/MisReport/RiskProfile"));
const SystematicsPlansAllClients = React.lazy(() => import("../screens/Admin/MisReport/SystematicsPlansAllClients"));
const AdviceLogBook = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBook"));
const AdviceLogBookAdd = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBookAdd"));
const AdviceLogBookArchived = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBookArchived"));
const ActionPlanLog = React.lazy(() => import("../screens/Admin/MisReport/ActionPlanLog"));
const AdviceTransaction = React.lazy(() => import("../screens/Admin/MisReport/AdviceTransaction"));
const MfTransactionReportAllClient = React.lazy(() => import("../screens/Admin/MisReport/MfTransactionReportAllClient"));
const MfHoldingClientWise = React.lazy(() => import("../screens/Admin/MisReport/MfHoldingClientWise"));
const ShareHoldingClientWise = React.lazy(() => import("../screens/Admin/MisReport/ShareHoldingClientWise"));
const MutualFundHolding = React.lazy(() => import("../screens/Admin/MisReport/MFHolding"));
const MFHoldingsSchemeWise = React.lazy(() => import("../screens/Admin/MisReport/MFHolding"));
const SharesHoldingCompanyWise = React.lazy(() => import("../screens/Admin/MisReport/SharesHoldingCompanyWise "))
const ShareTransactionReportAllClient = React.lazy(() => import("../screens/Admin/MisReport/SahreTransactionReportAllClient"));
const SystematicInvestments = React.lazy(() => import("../screens/Admin/MisReport/SystematicInvestment"));
const AdminHoldingReport = React.lazy(() => import("../screens/Admin/MisReport/AdminHoldingReport"));
const AuAReport = React.lazy(() => import("../screens/Admin/MisReport/AuAReport"));
const AuAReportGrid = React.lazy(() => import("../screens/Admin/MisReport/AuAReportGrid"));
const ClientTaxPlanningNewRegime = React.lazy(() => import("../screens/DataEntryOperator/Reports/Client/TaxCalculationReport"));
const ClientTaxPlanningOldRegime = React.lazy(() => import("../screens/DataEntryOperator/Reports/Client/TaxCalculationReportOldRegim"));

// ADMIN


// Dashboard ViewDetails

const SubmitDataViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminDashboardViewDetailsPages/SubmitDataViewDetails"));
const EditSubmitDataForPlanning = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminDashboardViewDetailsPages/EditSubmitDataForPlanning"));
const AuaAssetViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AuaAsset/AuaAssetViewDetails"));
const AdminAseetUnderManagementViewDetail = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminAssetUnderManagementViewDetails/AdminAssetUnderManagementViewDetail"));
const AdminAuaAseetsShares = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminAuaAseetsShares/AdminAuaAssetsSharesViewDetails"));
const AdminClientPortfolioViewDetail = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminClientPortfolioViewDetail/AdminClientPortfolioViewDetail"));
const AdminLockedAccountsViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminLockedAccountsViewDetails/AdminLockedAccountsViewDetails"));
const AdminSipBookViewDetail = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminSipBookViewDetail/AdminSipBookViewDetail"));
const AdminExpiringSystematicPlansViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/ExpiringSystematicPlans/AdminExpiringSystematicPlansViewDetails"));
const ClientNotes = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/ClientNotes"));

// 1) Accouting

const ExpenseVoucher = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/ExpenseVoucher"));
const AddExpenseVouchers = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/AddExpenseVouchers"));
const UploadInvoiceBill = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/UploadInvoiceBill"));
const FeeMandates = React.lazy(() => import("../screens/Admin/Accouting/FeeMandates/FeeMandates"));
const AddFeeMandates = React.lazy(() => import("../screens/Admin/Accouting/FeeMandates/AddFeeMandates"));
const ArchivedFeeMandates = React.lazy(() => import("../screens/Admin/Accouting/FeeMandates/ArchivedFeeMandates"));
const MisFeeMandates = React.lazy(() => import("../screens/Admin/MisReport/MisFeeMandates"));

const ExportToExcel = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/ExporttoExcel"));
const VendorSuppliers = React.lazy(() => import("../screens/Admin/Accouting/VendorSupplier/VendorSupplier"));
const AddVendorSupplier = React.lazy(() => import("../screens/Admin/Accouting/VendorSupplier/AddVendorSupplier"));
const ArchivedVendorsSuppliers = React.lazy(() => import("../screens/Admin/Accouting/VendorSupplier/ArchivedVendorsSuppliers"));
const AuaCalculation = React.lazy(() => import("../screens/Admin/Accouting/AuaCalculation/AuaCalculation"));
const ClientInvoiceAddress = React.lazy(() => import("../screens/Admin/Accouting/ClientInvoiceAddress/ClientInvoiceAddress"));
const EditClientInvoiceAddress = React.lazy(() => import("../screens/Admin/Accouting/ClientInvoiceAddress/EditClientInvoiceAddress"));
const Invoice = React.lazy(() => import("../screens/Admin/Invoices/Invoices"));
const AddInvoice = React.lazy(() => import("../screens/Admin/Invoices/AddInvoice"));
const ExportIncomeToExcel = React.lazy(() => import("../screens/Admin/Invoices/ExportIncomeToExcel"));
const Cancelled = React.lazy(() => import("../screens/Admin/Invoices/Cancelled"));
const Submitted = React.lazy(() => import("../screens/Admin/Invoices/Submitted"));
const Paid = React.lazy(() => import("../screens/Admin/Invoices/Paid"));


const CompnayBankAccount = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/CompnayBankAccount"));
const CompBankAccountPassbook = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/CompBankAccountPassbook"));
const AddCompBankPassbookEntry = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/AddCompBankPassbookEntry"));
const AddCompanyBankAccount = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/AddCompanyAccount"));
const ImportBankPassbookDetails = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/ImportBankPassbookDetail"));
const ArchivedCompanyBankAccount = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/ArchivedCompanyBankAccount"));


const InsurancePayoutDetails = React.lazy(() => import("../screens/InsurancePayoutDetails"));
const ArchivedRiders = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/ArchivedRiders"));


const MinutesOfMeeting = React.lazy(() => import("../screens/DataEntryOperator/Action/MinutesOfMeeting"));
const AddMoM = React.lazy(() => import("../screens/Admin/AddMoM"));
// const ClientMinutesOfMeeting = React.lazy(() => import( "../screens/DataEntryOperator/Action/ClientMinutesOfMeeting"));

const AdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/AdviceRequest"));
const AddAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/AddAdviceRequest"));
// const AdminDashboard = React.lazy(() => import("../screens/Admin/AdminDashboard"));

// Financial Plaing 
const FanancialPlaning = React.lazy(() => import("../screens/Admin/FinancialPlanning/FanancialPlaning"));
const LifeInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/LifeInsurance"));
const RetirementPlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/RetirementPlanning"));
const HouseholdersInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/HouseholdersInsurance"));
const VehicleInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/VehicleInsurance"));
const AccidentInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/AccidentInsurance"));
const HealthcareContingencyFund = React.lazy(() => import("../screens/Admin/FinancialPlanning/HealthcareContingencyFund"));
const Contingency = React.lazy(() => import("../screens/Admin/FinancialPlanning/Contingency"));
const HealthInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/HealthInsurance"));

const LumpSumCalculation = React.lazy(() => import("../screens/Admin/FinancialPlanning/LumpSumCalculation"));
const TaxPlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanning"));
const TaxPlanningNewRegimeSelf = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningNewRegimeSelf"));
const TaxPlanningOldRegimeSelf = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningOldRegimeSelf"));
const TaxPlanningNewRegimeSpouse = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningNewRegimeSpouse"));
const TaxPlanningOldRegimeSpouse = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningOldRegimeSpouse"));
const AssetMapping = React.lazy(() => import("../screens/Admin/FinancialPlanning/AssetMapping"));
const FpClientPortfolio = React.lazy(() => import("../screens/Admin/FinancialPlanning/ClientPortfolio/FpClientPortfolio"));
const ClientPortfolioPassbook = React.lazy(() => import("../screens/Admin/FinancialPlanning/ClientPortfolio/ClientPortfolioPassbook"));
const TaxPlans = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlans/TaxPlans"));
const ProactiveAdvices = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvices"));
const ProactiveAdvicesCancellation = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesCancellation"));
const ProactiveAdvicesInvestments = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesInvestments"));
const ProactiveAdvicesInvestmentsEdit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesInvestmentsEdit"));
const ProactiveAdvicesRedemption = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesRedemption"));
const ProactiveAdvicesBulkRedemption = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveAdvicesBulkRedemption"));
const ProactiveAdvicesBulkInvestment = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveAdvicesBulkInvestment"));
const ProactiveRequestBulkInvestmentSentForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentSentForApproval"));
const ProactiveRequestBulkInvestmentCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentCompleted"));
const ProactiveRequestBulkInvestmentDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentDeleted"));
const ProactiveRequestBulkInvestmentApprovalDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentApprovalDeleted"));
const ProactiveRequestBulkRedemptionApprovalDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkRedemptionApprovalDeleted"));
const ProactiveAdvicesInvestment = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesInvestmentManage"));
const ProactiveAdvicesRedemptionSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestSentForApproval"));
const ProactiveBulkAdvicesRedemptionSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkAdviceRequestSentForApproval"));
const ProactiveBulkAdvicesRedemptionCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkAdviceRequestCompleted"));
const ProactiveBulkAdvicesRedemptionDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkAdviceRequestDeleted"));
const ProactiveAdvicesInvestmentSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestInvestmentSentForApproval"));
const ProactiveAdvicesRedemptionCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestCompleted"));
const ProactiveAdvicesInvestmentCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestInvestmentCompleted"));
const ProactiveAdvicesRedemptionDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestDeleted"));
const ProactiveAdvicesInvestmentDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestInvestmentDeleted"));
const ProactiveAdvicesActiveSplit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesActiveSplit"));
const ProactiveAdvicesCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesCompleted"));
const ProactiveAdvicesDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesDeleted"));
const FinancialPlanLoans = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlanLoans"));
const CapitalAllocationInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/CapitalAllocationInsurance"));
const SipCalculation = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/SipCalculation"));
const GoalStp = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/GoalStp"));
const GoalSwp = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/GoalSwp"));
const GoalComments = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/GoalComments"));
const InvestmentComments = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/InvestmentComments"));
const Investment = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/Investment"));
const ImmediateCashFlowPlan = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/ImmediateCashFlowPlan"));
const AnnualSpendings = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/AnnualSpendings"));
const EstatePlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/EstatePlanning"));
const ProposedActionPlan = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/ProposedActionPlan"));
const EvaluationReport = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/EvaluationReport"));
const DisclaimersDisclosures = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/DisclaimersDisclosures"));
const SignOff = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/SignOff"));
const ClosePlan = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/ClosePlan"));
const StartPlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/StartPlanning"));

// Client Advice Request Head side Manage page, Lumpsum, Redemption
const ManageAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequest"));
const ManageAdviceRequestSentForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequestSentForApproval"));
const ManageAdviceRequestDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequestDeleted"));
const ManageAdviceRequestCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequestCompleted"));


const LumpsumAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/LumpsumAdviceRequest"));
const SipCancellationAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/SipCancellationAdviceRequest"));
const SipPauseAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/SipPauseAdviceRequest"));
const RedemptionAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/RedemptionAdviceRequest"));
const ProactiveRedemptionAdviceRequestAdd = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveRedemptionAdviceRequest-Add"));
const ProactiveBulkInvestmentAdviceRequestAdd = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkInvestmentAdviceRequestAdd"));
const ProactiveBulkRedemptionAdviceRequestAdd = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkRedemptionAdviceRequest-Add"));
const ProactiveBulkRedemptionAdviceRequestEdit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkRedemptionAdviceRequest-Edit"));
const ProactiveRedemptionAdviceRequestEdit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveRedemptionAdviceRequest-Edit"));
const SipInvestmentAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/SipInvestmentAdviceRequest"));
// Financial Plaing Report

const FinancialPlanningReport = React.lazy(() => import("../screens/Admin/FinancialPlanning/Report/FinancialPlanningReport"));

// HR

const Employees = React.lazy(() => import("../screens/Admin/HR/Employee"));
const AddEmployee = React.lazy(() => import("../screens/Admin/HR/AddEmployee"));
const EditEmployee = React.lazy(() => import("../screens/Admin/HR/EditEmployee"));
const ArchivedEmployees = React.lazy(() => import("../screens/Admin/HR/ArchivedEmployee"));
const DraftEmployees = React.lazy(() => import("../screens/Admin/HR/DraftEmployees"));
const EmployeeOnboarding = React.lazy(() => import("../screens/Admin/HR/EmployeeOnboarding"));
const EmployeeMenu = React.lazy(() => import("../screens/Admin/HR/EmployeeMenu"));
const EmployeeMenuSelection = React.lazy(() => import("../screens/Admin/HR/EmployeeMenuSelection/EmployeeMenuSelection"));
const AddEmployeeMenuSelection = React.lazy(() => import("../screens/Admin/HR/EmployeeMenuSelection/AddEmployeeMenuSelection"));
const EmployeesEntry = React.lazy(() => import("../screens/Admin/HR/EmployeesEntry"));
const EditEmployeeEntry = React.lazy(() => import("../screens/Admin/HR/EditEmployeeEntry"));
const ArchivedEmployeeEntry = React.lazy(() => import("../screens/Admin/HR/ArchivedEmployeesEntry"));
const EmployeesExit = React.lazy(() => import("../screens/Admin/HR/EmployeesExit"));
const EditEmployeeExit = React.lazy(() => import("../screens/Admin/HR/EditEmployeeExit"));
const ArchivedEmployeeExit = React.lazy(() => import("../screens/Admin/HR/ArchivedEmployeesExit"));
const LeaveType = React.lazy(() => import("../screens/Admin/HR/LeaveType"));
const AddLeaveType = React.lazy(() => import("../screens/Admin/HR/AddLeaveType"));
const HolidayCalender = React.lazy(() => import("../screens/Admin/HR/HolidayCalender"));
const AddHoliday = React.lazy(() => import("../screens/Admin/HR/AddHoliday"));
const HolidayCalenderForEmplyoee = React.lazy(() => import("../screens/Admin/HR/HolidayCalenderForEmplyoee"));

// Masters

const Clients = React.lazy(() => import("../screens/Admin/Masters/Clients"));
const DraftClients = React.lazy(() => import("../screens/Admin/Masters/Clients/DraftClients"));
const AddNewClient = React.lazy(() => import("../screens/Admin/Masters/Clients/AddNewClient"));
const ContractDetails = React.lazy(() => import("../screens/Admin/Masters/Clients/ContractDetails"));
const Onboarding = React.lazy(() => import("../screens/Admin/Masters/Clients/Onboarding"));
const PanVarification = React.lazy(() => import("../screens/Admin/Masters/Clients/PanVarification"));
const MenuSelection = React.lazy(() => import("../screens/Admin/Masters/Clients/MenuSelection"));
const ClientCisDetails = React.lazy(() => import("../screens/Admin/Masters/Clients/CisDetails"));
const MailGroup = React.lazy(() => import("../screens/Admin/Masters/Clients/MailGroups"));
const AddClients = React.lazy(() => import("../screens/Admin/Masters/AddClients"));
const ClientSubscribedServices = React.lazy(() => import("../screens/Admin/Masters/SubscribedServices"));
const AddNewServices = React.lazy(() => import("../screens/Admin/Masters/AddNewServices"));
const AdvisorGoals = React.lazy(() => import("../screens/Admin/Masters/AdvisorGoals"));
const ClientArchivedSubscribedServices = React.lazy(() => import("../screens/Admin/Masters/ArchivedSubscribedServices"));
const ArchivedClients = React.lazy(() => import("../screens/Admin/Masters/ArchivedClients"));
const Slabs = React.lazy(() => import("../screens/Admin/Masters/Slabs"));
const ArchivedSlabs = React.lazy(() => import("../screens/Admin/Masters/ArchivedSlabs"));
const AddSlab = React.lazy(() => import("../screens/Admin/Masters/AddSlab"));
const Announcements = React.lazy(() => import("../screens/Admin/Masters/Announcements"));
const AddAnnouncements = React.lazy(() => import("../screens/Admin/Masters/AddAnnouncements"));
const ArchivedAnnouncements = React.lazy(() => import("../screens/Admin/Masters/ArchivedAnnouncement"));
const Assumptions = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/Assumptions"));
const EditAssumption = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/EditAssumption"));
const ModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ModelPortfolios"));
const Comments = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/Comments"));
const AddComments = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddComments"));
const ArchivedComments = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ArchivedComments"));
const DisclaimerAndDiscloser = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/DisclaimerAndDiscloser"));
const EditDisclaimerAndDiscloser = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/EditDisclaimerAndDiscloser"));
const MalingGroups = React.lazy(() => import("../screens/Admin/Masters/MalingGroups"));
const AddMailingGroup = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddMailingGroup"));
const GroupsUserOf = React.lazy(() => import("../screens/Admin/Masters/GroupsUserOf"));
const AddGroupUser = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddGroupUser"));
const AddModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddModelPortfolios"));
const ViewModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ViewModelPortfolios"));

const GlobalParameter = React.lazy(() => import("../screens/Admin/Masters/GlobalParameter"));
const EditGlobalParameter = React.lazy(() => import("../screens/Admin/Masters/EditGlobalParameter"));
const ArchivedModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ArchivedModelPortfolio"));
const EditGlobalParameterFeeStructure = React.lazy(() => import("../screens/Admin/Masters/EditGlobalParameterFeeStructure"));
const BusinessAccreditation = React.lazy(() => import("../screens/Admin/Masters/BusinessAccreditation"));
const AddBusinessAccreditation = React.lazy(() => import("../screens/Admin/Masters/AddBusinessAccreditation"));
const MasterCompanyMaster = React.lazy(() => import("../screens/Admin/Masters/MasterCompanyMaster"));
const CompanyBankAccounts = React.lazy(() => import("../screens/Admin/Masters/CompanyBankAccounts"));
const ArchivedBusinessAccreditation = React.lazy(() => import("../screens/Admin/Masters/ArchivedBusinessAccreditation"));
const Branches = React.lazy(() => import("../screens/Admin/Masters/Branches"));
const ArchivedBranches = React.lazy(() => import("../screens/Admin/Masters/ArchivedBranches"));
const CompanySignOffDetails = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/CompanySignOffDetails"));
const EditCompanySignOffDetails = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/EditCompanySignOffDetails"));
const InsuranceProductRecommendations = React.lazy(() => import("../screens/Admin/Masters/Recommendations/InsuranceProductRecommendations"));
const SendMailtoGroup = React.lazy(() => import("../screens/Admin/Masters/SendMailtoGroup"));
const MailTemplates = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/MailTemplate"));
const CreateNewTemplate = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/CreateNewTemplate"));
const ArchivedMailTemplates = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/ArchivedMailTemplate"));
const CopyRecordFromMasterTemplate = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/CopyRecordFromMasterTemplate"));
const InvestmentProduct = React.lazy(() => import("../screens/Admin/Masters/Recommendations/InvestmentProduct"));
const ArchivedInvestmentProduct = React.lazy(() => import("../screens/Admin/Masters/Recommendations/ArchivedInvestmentProduct"));
const AddInvestmentProduct = React.lazy(() => import("../screens/Admin/Masters/Recommendations/AddInvestmentProduct"));
const ArchivedMailingGroup = React.lazy(() => import("../screens/Admin/Masters/ArchivedMailingGroup"));
const ArchivedAdvisors = React.lazy(() => import("../screens/SuperAdmin/Master/Advisors/ArchivedAdvisors"));
const AddBranches = React.lazy(() => import("../screens/Admin/Masters/AddBranches"));
const EditCompanyDetails = React.lazy(() => import("../screens/Admin/Masters/EditCompanyDetails"));
const DesiredAssetAllocation = React.lazy(() => import("../screens/Admin/Masters/DesiredAssetAllocation/DesiredAssetAllocation"));
const ArcheivedDesiredAssetAllocation = React.lazy(() => import("../screens/Admin/Masters/DesiredAssetAllocation/ArcheivedDesiredAssetAllocation "));
const AddDesiredAssetAllocation = React.lazy(() => import("../screens/Admin/Masters/DesiredAssetAllocation/AddDesiredAssetAllocation "));
const AnnualComplianceAuditReports = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/AnnualComplianceAuditReports"));
const AddAnnualComplianceAuditReports = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/AddAnnualComplianceAuditReports"));
const GrievanceRedressalMechanisms = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/GrievanceRedressalMechanisms"));
const RiskProfileIntroduction = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfileIntroduction"));
const RiskProfileDisclaimer = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfileDisclaimer"));
const AddRiskProfileDisclaimer = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/AddRiskProfileDisclaimer"));
const ArchivedRiskProfileDisclaimer = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/ArchivedRiskProfileDisclaimer"));
const RiskProfilesTypes = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfilesTypes"));
const RiskProfiles = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfiles"));
const AddRiskProfiles = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/AddRiskProfiles"));
const ArchivedRiskProfiles = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/ArchivedRiskProfiles"));
const RiskProfilesQA = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfilesQA"));
const ArchivedRiskProfilesQA = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/ArchivedRiskProfilesQA"));
const AddRiskProfilesQA = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/AddRiskProfilesQA"));
const ClientMenuSelection = React.lazy(() => import("../screens/Admin/Masters/CilentMenuSelection/ClientMenuSelection"));
const AddClientMenuSelection = React.lazy(() => import("../screens/Admin/Masters/CilentMenuSelection/AddClientMenuSelection"));







// BD

const AuaSelection = React.lazy(() => import("../screens/Admin/BD/AuaSelection"));
const EditAuaSelection = React.lazy(() => import("../screens/Admin/BD/EditAuaSelection"));

// Operation
const MfUnitsReconciliation = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliation"));
const MfUnitsReconciliationUnmatch = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliationUnmatch"));
const MfUnitsReconciliationInSystem = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliationInSystem"));
const MfUnitsReconciliationNotRta = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliationNotRta"));
const ImportUnitReconciliation = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/ImportUnitReconciliation"));
const FixedIncomeTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/FixedIncomeTransactions/FixedIncomeTransactions"));
const FilesUpload = React.lazy(() => import("../screens/Admin/Accouting/Operation/FilesUpload/TransactionFilesUpload"));
const ShareTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ShareTransactions"));
const ShareSystematicTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareSystematicTransactions/Platform"));
const ShareTransactionsFuture = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Future"));
const ShareTransactionsPlatform = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Platform"));
const ShareTransactionInProcess = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/InProcess"));
const ShareTransactionError = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Error"));
const ShareTransactionsReady = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Ready"));
const ArchivedSips = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ArchivedSips"));
const ShareTransactionsImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ShareTransactionImport"));
const ShareTransactionsArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ShareTransactionsArchived"));

const MfTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactions"));
const MfTransactionsPlatform = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactionsPlatform"));
const MfTransactionsFuture = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactionsFuture"));
const MfTransactionsTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Transactions"));
const MfTransactionsError = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Error"));
const MfTransactionsReady = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Ready"));
const MfTransactionsArchive = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Archived"));
const MfTransactionsArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactionsArchived"))
const MfTransactionImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/ImportTransaction"))
const MfSystematicTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicTransactions"));
const MfSystematicPlatformImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/ImportTransaction"))
const MfSystematicArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicArchived"));
const MfSystematicError = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicError"));
const MfSystematicReady = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicReady"));
const MfSystematicTransactiontab = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicTransactiontab"));
const CisDetails = React.lazy(() => import("../screens/Admin/Accouting/Operation/CisDetails/CisDetails"));
const ArcheivedCisDetails = React.lazy(() => import("../screens/Admin/Accouting/Operation/CisDetails/ArcheivedCisDetails"));
const EditCisDetails = React.lazy(() => import("../screens/Admin/Accouting/Operation/CisDetails/EditCisDetails"));
const MfSystematicFuture = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicFuture"));
const MfSystematicPlatform = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicPlatform"));
const MfSystematicPaused = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicPaused"));
const MfSystematicImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicImport"));
const MfSysArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSysArchived"));
const ClientEntry = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ClientEntry"));
const ArchivedClientsEntry = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ArchivedClient"));
const ClientExit = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ClientExit"));
const EditClientExit = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/EditClientExit"));
const ArchivedClientExit = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ArchivedClientExit"))
const EditClientEntry = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/EditClientEntry"));
const Mandates = React.lazy(() => import("../screens/Admin/Accouting/Operation/AccountOpening/Mandates"));
const AddMandates = React.lazy(() => import("../screens/Admin/Accouting/Operation/AccountOpening/AddMandates"));
const ArchivedMandates = React.lazy(() => import("../screens/Admin/Accouting/Operation/AccountOpening/ArchivedMandates"));

// 

const MutualFundRtaCodes = React.lazy(() => import("../screens/Admin/MisReport/MutualFundRTAFund"));
const ArchivedMutualFundRtaCodes = React.lazy(() => import("../screens/Admin/MisReport/ArchivedMutualFundRTAFund.tsx"));
const EightyCReport = React.lazy(() => import("../screens/Admin/MisReport/EightyCReport"));

// Financial Plans

const FinancialPlans = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/FinancialPlans"));
const FinancialPlansHomePage = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/FinancialPlansHomePage"));
const FinancialPlanningShare = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/Share/FinancialPlanningShare"));
const FinancialPlanningMutualFund = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/MutualFunds/FinancialPlanningMutualFund"));
const FinancialPlanningUlip = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/Ulip/FinancialPlanningUlip"));
const FinancialPlanningMoneyBack = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/MoneyBack/FinancialPlanningMoneyBack"));
const FinancialPlanningFixedIncome = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/FixedIncome'))
const FinancialPlanningRetirementProducts = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/RetirementProducts'))
const FinancialPlanningBullion = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/Bullion'))
const FinancialPlanningRealEstate = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/RealEstate'))
const FinancialPlanningBankAndDMat = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlanningBankAndDmat"));
const FinancialPlanningCoverPage = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlanningCoverPage"));

const FinancialPlanReport = React.lazy(() => import('../screens/DataEntryOperator/Report'))




// Super Admin

// 1) Dashboard 


// 2) Masters 

const CompanyMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyDetails/CompanyMaster")));
const AddCompanyMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyDetails/AddCompanyMaster")));
const ArchivedCompanyMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyDetails/ArchivedCompanyMaster")));
const MenuOrganizer = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MenuOrganizer/MenuOrganizer")));
const AddMenuOrganizer = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MenuOrganizer/AddMenuOrganizer")));
const ArchivedMenuOrganizer = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MenuOrganizer/ArchivedMenuOrganizer")));
const Advisors = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Advisors/Advisors")));
const AddAdvisors = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Advisors/AddAdvisors")));
const RiskProfilesTypesSuperAdmin = React.lazy(() => import("../screens/SuperAdmin/Master/RiskProfile/RiskProfilesTypes"));


const ClientPortfolio = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/ClientPortfolio")));
const AddClientPortfolio = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/AddClientPortfolio")));
const ArchivedClientPortfolio = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/ArchivedClientPortfolio")));
const ArchivedProductCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/ArchivedProductCategories")));
const CisMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CisMaster/CisMaster")));
const AddCisMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CisMaster/AddCisMaster")));
const ArchivedCisMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CisMaster/ArchivedCisMaster")));
const ClientOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientOnboardingChecklistMaster/ClientOnboardingChecklistMaster")));
const AddClientOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientOnboardingChecklistMaster/AddClientOnboardingChecklistMaster")));
const ArchivedClientOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientOnboardingChecklistMaster/ArchivedClientOnboardingChecklistMaster")));
const ClientClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientClearanceChecklistMaster/ClientClearanceChecklistMaster")));
const AddClientClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientClearanceChecklistMaster/AddClientClearanceChecklistMaster")));
const ArchivedClientClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientClearanceChecklistMaster/ArchivedClientClearanceChecklistMaster")));
const EmployeeOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeOnboardingChecklistMaster/EmployeeOnboardingChecklistMaster")));
const AddEmployeeOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeOnboardingChecklistMaster/AddEmployeeOnboardingChecklistMaster")));
const ArchivedEmployeeOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeOnboardingChecklistMaster/ArchivedEmployeeOnboardingChecklistMaster")));
const EmployeeClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeClearanceChecklistMaster/EmployeeClearanceChecklistMaster")));
const AddEmployeeClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeClearanceChecklistMaster/AddEmployeeClearanceChecklistMaster")));
const ArchivedEmployeeClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeClearanceChecklistMaster/ArchivedEmployeeClearanceChecklistMaster")));
const NotificationMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationMaster")));
const AddNotificationMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/AddNotificationMaster")));
const NotificationTitle = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationTitle")));
const AddNotificationTitle = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/AddNotificationTitle")));
const ArchivedNotificationTitle = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/ArchivedNotificationTitle")));
const ArchivedNotificationMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/ArchivedNotificationMaster")));
const NotificationStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationStatus")));
const NotificationArchivedStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationArchivedStatus")));
const NotificationReadStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationReadStatus")));
const TaskMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/TaskMaster/TaskMaster")));
const AddTaskMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/TaskMaster/AddTaskMaster")));
const ArchivedTaskMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/TaskMaster/ArchivedTaskMaster")))

// Upload Document 
const UploadDocument = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/UploadDocument/UploadDocument")));

//Help

const HelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/HelpMaster")));
const ClientHelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/ClientHelpMaster")));
const FinancialPlanningHelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/FinancialPlanningHelpMaster")));

// Document Master 

const DocumentMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/DocumentsMaster/DocumentsMaster")));
const AddDocumentMaster = React.lazy(() => import("../screens/SuperAdmin/DocumentsMaster/AddDocumentsMaster"));
const ArchivedDocumentsMaster = React.lazy(() => import("../screens/SuperAdmin/DocumentsMaster/ArchivedDocumentsMaster"));

// Role Management 

const RoleManagment = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/RoleManagment/RoleManagment")));
const RoleManagmentPermission = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/RoleManagment/RoleManagementPermission")));
const CreateRoleManagement = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/RoleManagment/CreateRoleManagement")));

// Mis Report
const AdvisorsAua = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/AdvisorsAua")));
const MisShares = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/MisShares")));
const MisMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/MisMutualFunds")));
const SignzyReport = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/SignzyReport")));
//  Mail Template

const MailTemplate = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MailTemplate/MailTemplate")));
const AddMailTemplate = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MailTemplate/AddMailTemplate")));


//3) Assumption Master 

const AssumptionMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AssumptionMaster/AssumptionMaster")));
const AddAssumptionMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AssumptionMaster/AddAssumptionMaster")));
const ArchivedAssumptionMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AssumptionMaster/ArchivedAssumptionMaster")));

// 1) Advisor Goal Master

const GoalLiablities = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/GoalLiablities/GoalLiablities")));
const AddGoalLiablities = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/GoalLiablities/AddGoalLiablities")));
const ArchivedGoalLiablities = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/GoalLiablities/ArchivedGoalLiablities")));

const InvestmentObjectives = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/InvestmentObjectives/InvestmentObjectives")));
const AddInvestmentObjectives = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/InvestmentObjectives/AddInvestmentObjectives")));

//  2) Accouting Master

const FinancialYear = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/FinancialYear")));
const EditFinancialYear = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/EditFinancialYear")));
const CostInflation = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/CostInflation")));
const AddCostInflation = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/AddCostInflation")));
const ArchivedCostInflation = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/ArchivedCostInflation")));
const GstMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/GstMaster")));
const AddGstMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/AddGstMaster")));
const ArchivedGstMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/ArchivedGstMaster")));


// 3)Product Master 

const ProductCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ProductCategories")));
const AddProductCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/AddProductCategories")));


// 1) Insurance

const InsuranceTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceTypes/InsuranceTypes")));
const AddInsuranceTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceTypes/AddInsuranceTypes")));
const InsuranceSubTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceSubTypes/InsuranceSubTypes")));
const AddInsuranceSubTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceSubTypes/AddInsuranceSubTypes")));
const BenefitsAvailable = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/BenefitsAvailable/BenefitsAvailable")));
const AddBenifitsAvailable = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/BenefitsAvailable/AddBenefitsAvailable")));
const NatureOfPolicy = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/NatureOfPolicy/NatureOfPolicy")));
const AddNatureOfPolicy = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/NatureOfPolicy/AddNatureOfPolicy")));
const Riders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/Riders")));
const AddRiders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/AddRiders")));
const InsuranceCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceCategories/InsuranceCategories")));
const AddInsuranceCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceCategories/AddInsuranceCategories")));
const AnnuityTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/AnnuityTypes/AnnuityTypes")));
const AddAnnuityTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/AnnuityTypes/AddAnnuityTypes")));
const TransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/TransactionType/TransactionType")));
const AddTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/TransactionType/AddTransactionType")));
const ArchivedInsuranceTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceTypes/ArchivedInsuranceTypes")));
const ArchivedInsuranceSubTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceSubTypes/ArchivedSubTypes")));
const ArchivedBenefitsAvailable = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/BenefitsAvailable/ArchivedBenifitsAvailable")));
const ArchivedNatureOfPolicy = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/NatureOfPolicy/ArchivedNatureOfPolicy")));
const AddInsuranceRiders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/AddInsuranceRiders")));
const ArchivedInsuranceRiders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/ArchivedInsuranceRiders")));
const ArchivedInsuranceCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceCategories/ArchivedInsuranceCategories")));
const ArchivedAnnuityTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/AnnuityTypes/ArchivedAnnuityTypes")));

// operationTransactionTypeMaster
const OperationTransactionTypeMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/TransactionTypeMaster/OperationTransactionTypeMaster")));
const AddOperationTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/TransactionTypeMaster/AddOperationTransactionType")));
const ArchivedOperationTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/TransactionTypeMaster/ArchivedOperationTransactionType")));

// 2)Mutual Funds

const Taxaction = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/Taxaction/Taxaction")));
const AddTaxaction = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/Taxaction/AddTaxaction")));
const MutualFundsCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsCategories/MutualFundsCategories")));
const AddMutualFundsCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsCategories/AddMutualFundsCategories")));
const MutualFundsSubCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsSubCategories/MutualFundsSubCategories")));
const AddMutualFundsSubCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsSubCategories/AddMutualFundsSubCategories")));
const ArchivedTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/TransactionType/ArchivedTransactionType")));
const ArchivedTaxaction = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/Taxaction/ArchivedTaxaction")));
const ArchivedMutualFundsCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsCategories/ArchivedMutualFundCategories")));
const ArchivedMutualFundsSubCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsSubCategories/ArchivedMutualFundSubCategories")));

// Share Master
// 1)Market Cap
const MarketCapMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MarketCapMaster/MarketCapManage")));
const MarketCapAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MarketCapMaster/MarketCapAdd")));
const MarketCapArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MarketCapMaster/MarketCapArchived")));

// 2)Product Type
const ProductTypeMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductType/ProductTypeMasterManage")));
const ProductTypeAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductType/ProductTypeAdd")));
const ProductTypeArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductType/ProductTypeArchived")));

// 3)Asset Class
const AssetClassMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/AssetClass/AssetClassManage")));
const AssetClassAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/AssetClass/AssetClassAdd")));
const AssetClassArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/AssetClass/AssetClassArchived")));

// 4)Industry
// const IndustryMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Industry/IndustryManage")));
// const IndustryAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Industry/IndustryAdd")));
// const IndustryArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Industry/IndustryArchived")));

// 4)Sector
// const SectorMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Sector/SectorManage")));
// const SectorAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Sector/SectorAdd")));
// const SectorArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Sector/SectorArchived")));


// 3) Income

const IncomeCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeCategories/IncomeCtaegories")));
const AddIncomeCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeCategories/AddIncomeCategories")));
const IncomeHeads = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeHeads/IncomeHeads")));
const AddIncomeHeads = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeHeads/AddIncomeHeads")));
const ArchivedIncomeHeads = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeHeads/ArchivedIncomeHeads")));
const ArchivedIncomeCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeCategories/ArchivedIncomeCategories")));

// Ulip Funds 

const UlipFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/UlipFunds/UlipFunds")));
const ArchivedUlipFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/UlipFunds/ArchivedUlipFunds")));
const AddUlipFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/UlipFunds/AddUlipFunds")));

// 4) BondsAndDebentures 

const BondsAndDebentureFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/BondsAndDebentureFunds/BondsAndDebentureFunds")));
const AddBondAndDebentureFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/BondsAndDebentureFunds/AddBondAndDebentureFunds")));
const ArchivedBondsAndDebentureFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/BondsAndDebentureFunds/ArchivedBondsAndDebentureFunds")));


// 5) Real Estate

const PropertyType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/PropertyType/PropertyType")));
const AddPropertyType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/PropertyType/AddPropertyType")));
const OwnershipStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/OwnershipStatus/OwnershipStatus")));
const AddOwnershipStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/OwnershipStatus/AddOwnershipStatus")));
const ArchivedOwnershipStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/OwnershipStatus/ArchivedOwnershipStatus")));
const ArchivedPropertyType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/PropertyType/ArchivedPropertyType")));



// 6) Household

const HouseholdCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdCategoris/HouseholdCategories")));
const AddHouseholdCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdCategoris/AddHouseholdCategories")));
const HouseholdAssets = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdAssets/HouseholdAssets")));
const AddHouseholdAssets = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdAssets/AddHouseholdAssets")));
const HouseholdVehicles = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdsVehicles/HouseholdsVehicles")));
const AddHouseholdVehicles = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdsVehicles/AddHouseholdsVehicles")));
const SAArchivedHouseholdCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdCategoris/ArchivedHouseholdCategories")));
const ArchivedHouseholdAsset = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdAssets/ArchivedHouseholdAsset")));

// 7)Bank 

const LoanTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Loan Types/LoanTypes")));
const AddLoanTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Loan Types/AddLoanTypes")));
const ArchivedLoanTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Loan Types/ArchivedLoanTypes")));


// 8) Global Product Parameter 

const GlobalProductParameters = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/GlobalProductParameters/GlobalProductParameters")));
const AddGlobalProductParameters = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/GlobalProductParameters/AddGlobalProductParameters")));
const ArchivedGlobalProductParameters = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/GlobalProductParameters/ArchivedGlobalProductParameters")));


// 8) Establishments

const EstablishmentTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentTypes/EstablishmentTypes")));
const AddEstablishmentTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentTypes/AddEstablishmentTypes")));
const InsuranceCompanies = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/InsuranceCompanies/InsuranceCompanies")));
const AddInsuranceCompanies = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/InsuranceCompanies/AddInsuranceCompanies")));
const EstablishmentBank = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBank/EstablishmentBank")));
const AddEstablishmentBank = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBank/AddEstablishmentBank")));
const EstablishmentBranch = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBranch/EstablishmentBranch")));
const AddEstablishmentBranch = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBranch/AddEstablishmentBranch")));
const EstablishmentFinancialInstitution = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentFinancialInstitution/EstablishmentFinancialInstitution")));
const AddEstablishmentFinancialInstitution = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentFinancialInstitution/AddEstablishmentFinancialInstitution")));
const ArchivedEstablishmentFinancialInstitution = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentFinancialInstitution/ArchivedEstablishmentFinancialInstitution")));
const EstablishmentDepositoryParticipants = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentDepositoryParticipants/EstablishmentDepositoryParticipants")));
const AddEstablishmentDepositoryParticipants = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentDepositoryParticipants/AddEstablishmentDepositoryParticipants")));
const EstablishmentMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentMutualFund/EstablishmentMutualFund")));
const AddEstablishmentMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentMutualFund/AddEstablishmentMutualFund")));
const ArchivedEstablishmentTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentTypes/ArchivedEstablishmentTypes")));
const ArchivedInsuranceCompanies = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/InsuranceCompanies/ArchivedInsuranceCompanies")));
const ArchivedEstablishmentBank = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBank/ArchivedEstablishmentBank")));
const ArchivedEstablishmentBranch = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBranch/ArchivedEstablishmentBranch")));
const ArchivedEstablishmentDepositoryParticipants = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentDepositoryParticipants/ArchivedEstablishmentDepositoryParticipants")));
const ArchivedEstablishmentMutualFund = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentMutualFund/ArchivedEstablishmentMutualFund")));
const P2pLendingMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/P2pLendingMaster/P2pLendingMaster")));
const AddP2pLendingMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/P2pLendingMaster/AddP2pLendingMaster")));
const ArchivedP2pLendingMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/P2pLendingMaster/ArchivedP2pLendingMaster")));


// 9) Product Parameter
//const FixedReturnAndRetirementProducts = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturns/FixedReturnAndRetirementProducts")));
const InsuranceProduct = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/InsuranceProduct/InsuranceProduct")));
const AddInsuranceProduct = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/InsuranceProduct/AddInsuranceProduct")));
const ArchivedInsuranceProduct = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/InsuranceProduct/ArchivedInsuranceProduct")));
const SuperAdminMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/MutulFunds")));
const SuperAdminArchivedMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/ArchivedMutualFunds")));
const AddMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/AddMutualFunds")));
const MutualFundNavHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/MutualFundNavHistory")));
const AddMutualFundNavHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/AddMutualFundNavHistory")));
const MutualFundQuantitativeIndicators = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/MutualFundQuantitativeIndicators")));
const AddMutualFundQuantitativeIndicators = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/AddMutualFundQuantitativeIndicators")));
const SuperAdminShares = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/Shares")));
const AddSharesCompany = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/AddShareCompany")));
const SharesPriceHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/SharesPriceHistory")));
const AddSharesPriceHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/AddSharesPriceHistory")));
const EditSharesPriceHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/EditSharesHistorylPrice")));
const QuaterlyHistoricData = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/QuaterlyHistoricData")));
const AddQuaterlyHistoricData = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/AddQuaterlyHistoricData")));
const ArchivedShares = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/ArchivedShares")));

// Operations
const MfTransactionsErrorsMissingSchemes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/MfTransactionsErrorsMissingSchemes")));
const MatchedScheme = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/matchedScheme")));
const SchemeMissingInSFA = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInSfa")));
const SchemeMIssingInAccord = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInAccord")));
const SchemeMIssingInAccordRTA = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInAccordRTA")));
const SchemeMIssingInAccordAMFI = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInAccordAMFI")));

const MFSchemeIsVerified = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/MFSchemeIsVerified")));
const SharesMatchedScheme = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/shareMatchedScheme")));
const SharesSchemeMissing = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissing")));
const SharesSchemeMissingNSE = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingNSE")));
const SharesSchemeMissingISIN = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingISIN")));
const SharesSchemeMissingInAccord = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingInAccord")));
const SharesSchemeMissingInSFA = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingInSFA")));
const SharesSchemeIsVerified = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeIsVerified")));
const MfTransactionsErrorSchemeMapping = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/MfTransactionsErrorSchemeMapping")));
const MfTransactionsErrors = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/MfTransactionsErrors")));
const MFSchemeVerify = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/SchemeVerify")));
const ShareTransactionMissingCode = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/ShareTransactionsErrors/ShareTransactionsMissingCode")));
const ShareTransactionsError = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/ShareTransactionsErrors/ShareTranssactionsError")));
const ClientMigration = React.lazy(() => import("../screens/SuperAdmin/Operations/ClientMigration/ClientMigration"));
const AddClientMigration = React.lazy(() => import("../screens/SuperAdmin/Operations/ClientMigration/AddClientMigration"));

//Superadmin Stock Actions
const CorporateActions = React.lazy(() => import("../screens/SuperAdmin/StockActions/CorporateActions"));

const Navigation = () => {
  const login: any = useSelector<RootState, UserState>(
    (state: any) => state.userLogin
  );

  interface ProtectedRouteProps extends RoutesProps {
    isAuthenticated: boolean;
    authenticationPath: string;
  }

  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    isAuthenticated: localStorage.getItem("token") != null,
    authenticationPath: "/login",
  };



  return (
    <>
      <div>
        <Routes>
          <Route path="/smallcase-blank-page" element={<SmallCaseSdkBlankPage />} />
          <Route path="/" element={<Navigate replace to="/login" />} />
          <Route
            path="/login"
            element={
              defaultProtectedRouteProps.isAuthenticated ||
                login.loginSuccess ? (
                <Navigate replace to="/dashboard" />
              ) : (
                <Login />
              )
            }
          />
          <Route path="/forget-password" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <ForgetPassword />
          </Suspense>} />
          <Route path="/set-password" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <SetPassword />
          </Suspense>} />
          <Route path="/members" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Members />
          </Suspense>} />
          <Route path="/add-member" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <AddMember />
          </Suspense>} />
          <Route path="/otp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Otp />
          </Suspense>} />
          <Route path="/welcome" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Welcome />
          </Suspense>} />
          <Route path="/self" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <SelfInfo />
          </Suspense>} />
          <Route path="/spouse" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <SpouseInfo />
          </Suspense>} />
          <Route path="/members-list" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <MembersList />
          </Suspense>} />


          <Route path="/register-otp/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Otp />
          </Suspense>} />

          {/* PROTECTED ROUTES */}
          <Route path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          >

            {/* DATA ENTRY OPERATOR */}

            {/* {HEADER} */}

            <Route path="/discrepancies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Discrepanices />
            </Suspense>} />

            <Route path="/alerts" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Alerts />
            </Suspense>} />
            <Route path="/my-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MyProfile />
            </Suspense>} />
            <Route path="/change-password" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ChangePassword />
            </Suspense>} />
            <Route path="/documents" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Documents />
            </Suspense>} />
            {/* 1) Dashboard Module */}




            <Route path="/review" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Review />
            </Suspense>} />
            <Route path="/review-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReviewDetails />
            </Suspense>} />
            <Route path="/review-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReviewArchived />
            </Suspense>} />
            <Route path="/dashboard" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DashBoard />
            </Suspense>} />
            <Route path="/client-notes/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientNotes />
            </Suspense>} />
            <Route path="/dashboard/risk-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UpdateRiskProfile />
            </Suspense>} />
            <Route path="/dashboard/new-risk-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfile />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQue />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile-manual" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQueManual />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile-system" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQueSystem />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile/:type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQue />
            </Suspense>} />
            <Route path="/dashboard/new-risk-profile-disclaimers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileDeclaimer />
            </Suspense>} />
            <Route path="/dashboard/new-risk-profile-override" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileOverride />
            </Suspense>} />
            <Route path="/dashboard/override-disclaimer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OverrideDisclaimer />
            </Suspense>} />
            <Route path="/dashboard/risk-profile-history" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilHistory />
            </Suspense>} />

            {/* Admin dashboard View Details */}

            <Route path="/dashboard/submit-data-view-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SubmitDataViewDetails />
            </Suspense>} />
            <Route path="/dashboard/edit-submit-data-view-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSubmitDataForPlanning />
            </Suspense>} />
            <Route path="/dashboard/edit-aua-asset" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuaAssetViewDetails />
            </Suspense>} />
            <Route path="/dashboard/asset-under-management" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminAseetUnderManagementViewDetail />
            </Suspense>} />
            <Route path="/dashboard/asset-under-management-shares" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminAuaAseetsShares />
            </Suspense>} />
            <Route path="/dashboard/client-portfolio-view-detail" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminClientPortfolioViewDetail />
            </Suspense>} />
            <Route path="/dashboard/locked-accounts" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminLockedAccountsViewDetails />
            </Suspense>} />
            <Route path="/dashboard/sip-book-view-detail" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminSipBookViewDetail />
            </Suspense>} />
            <Route path="/dashboard/expiring-systematic-plans" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminExpiringSystematicPlansViewDetails />
            </Suspense>} />

            {/* 2) Establishment Module */}
            <Route path="/establishment/establishment-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Establishment />
            </Suspense>} />

            {/* 2) Information Module */}
            <Route path="/information/personal/family" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Family />
            </Suspense>} />
            <Route path="/information/personal/add-member" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFamilyMember />
            </Suspense>} />
            <Route path="/information/personal/archived-family-member" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFamily />
            </Suspense>} />
            <Route path="/information/personal/edit-member/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFamilyMember />
            </Suspense>} />
            <Route path="/information/personal/edit-primary-member/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditFamilyMember />
            </Suspense>} />
            <Route path="/information/add-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBankAccount />
            </Suspense>} />
            <Route path="/information/edit-bank-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBankAccount />
            </Suspense>} />
            <Route path="/information/add-dmat-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDmatAccount />
            </Suspense>} />
            <Route path="/information/edit-dmat-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDmatAccount />
            </Suspense>} />
            <Route path="/information/add-investment-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMfCard />
            </Suspense>} />
            <Route path="/information/edit-investment-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMfCard />
            </Suspense>} />
            <Route path="/information/mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AccountMandates />
            </Suspense>} />
            <Route path="/information/add-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAccountMandates />
            </Suspense>} />
            <Route path="/information/edit-mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAccountMandates />
            </Suspense>} />
            <Route path="/information/archived-mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAccountMandates />
            </Suspense>} />
            <Route path="/information/accounts" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BankAccounts />
            </Suspense>} />
            <Route path="/information/income" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Income />
            </Suspense>} />
            <Route path="/information/add-income" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncome />
            </Suspense>} />
            <Route path="/information/edit-income/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncome />
            </Suspense>} />
            <Route path="/information/view-edit-income/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncome />
            </Suspense>} />
            <Route path="/information/archived-income" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncomeArchived />
            </Suspense>} />
            <Route path="/information/loans" element={<Suspense fallback={<> <Loader show={true} /> </>}  > <Loans />
            </Suspense>} />
            <Route path="/information/add-loan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoan />
            </Suspense>} />
            <Route path="/information/edit-loan/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoan />
            </Suspense>} />
            <Route path="/information/archived-loan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LoansArchived />
            </Suspense>} />
            <Route path="/information/amotization-loan/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LoansAmortization />
            </Suspense>} />
            <Route path="/information/import-amotization-loan/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImportAmotizationLoan />
            </Suspense>} />
            <Route path="/information/personal/address" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Address />
            </Suspense>} />
            <Route path="/information/personal/add-address" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAddress />
            </Suspense>} />
            <Route path="/information/personal/edit-address/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAddress />
            </Suspense>} />
            <Route path="/information/personal/archived-address" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddressArchivedList />
            </Suspense>} />



            <Route path="/information/personal/health-lifestyle" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HealthLifestyle />
            </Suspense>} />
            <Route path="/information/personal/add-health-lifestyle" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHealthLifestyle />
            </Suspense>} />
            <Route path="/information/personal/edit-health-lifestyle/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHealthLifestyle />
            </Suspense>} />
            <Route path="/information/personal/occupation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Occupation />
            </Suspense>} />
            <Route path="/information/personal/add-occupation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditOccupation />
            </Suspense>} />
            <Route path="/information/personal/edit-occupation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditOccupation />
            </Suspense>} />
            <Route path="/information/personal/view-edit-occupation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditOccupation />
            </Suspense>} />
            <Route path="/information/personal/archived-occupation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OccupationArchived />
            </Suspense>} />

            <Route path="/information/physical-assets/vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetsVehicle />
            </Suspense>} />
            <Route path="/information/physical-assets/add-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsVehicle />
            </Suspense>} />
            <Route path="/information/physical-assets/edit-vehicles/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsVehicle />
            </Suspense>} />
            <Route path="/information/physical-assets/archived-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetsVehicleArchived />
            </Suspense>} />
            <Route path="/information/physical-assets/household" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetHousehold />
            </Suspense>} />
            <Route path="/information/personal/add-household" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsHousehold />
            </Suspense>} />
            <Route path="/information/personal/edit-household/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsHousehold />
            </Suspense>} />
            <Route path="/information/personal/multiple-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MultipleAddHouseHold />
            </Suspense>} />
            <Route path="/information/personal/archived-household" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetHouseholdArchivedList />
            </Suspense>} />

            {/* Planing   */}

            <Route path="/planing/life-insrance-requirement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LifeInsuranceReq />
            </Suspense>} />
            <Route path="/planing/retirement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RetirementPlan />
            </Suspense>} />

            {/* 3) Portfolio */}
            <Route path="/portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Portfolio />
            </Suspense>} />
            <Route path="/portfolio/add-fixed-return" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturn />
            </Suspense>} />
            <Route path="/portfolio/edit-fixed-return/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturn />
            </Suspense>} />
            <Route path="/portfolio/view-fixed-return/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturn />
            </Suspense>} />
            <Route path="/portfolio/fixed-return" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturn />
            </Suspense>} />
            <Route path="/portfolio/fixed-return-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnArchieved />
            </Suspense>} />
            <Route path="/portfolio/fixed-return-interst-records/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnInterestRecords />
            </Suspense>} />
            <Route path="/portfolio/fixed-return-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnPassbook />
            </Suspense>} />
            <Route path="/portfolio/archived-fixed-return-interst-records" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnInterestRecordsArchived />
            </Suspense>} />
            <Route path="/portfolio/ppf-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PpfAccount />
            </Suspense>} />
            <Route path="/portfolio/add-ppf-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfAccount />
            </Suspense>} />
            <Route path="/portfolio/edit-ppf-acount/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfAccount />
            </Suspense>} />
            <Route path="/portfolio/ppf-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PpfPassbook />
            </Suspense>} />
            <Route path="/portfolio/add-ppfpassbook-entry/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/edit-ppfpassbook-entry/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/ppf-archived-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PpfArchivedAccounts />
            </Suspense>} />
            <Route path="/portfolio/ssy-add-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyAddAccount />
            </Suspense>} />
            <Route path="/portfolio/ssy-edit-acount/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyAddAccount />
            </Suspense>} />
            <Route path="/portfolio/ssy-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyAccount />
            </Suspense>} />
            <Route path="/portfolio/ssy-archived-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyArchivedAccounts />
            </Suspense>} />
            <Route path="/portfolio/ssy-account-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyPassbook />
            </Suspense>} />
            <Route path="/portfolio/add-ssy-passbook/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSsyPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/edit-ssy-passbook/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSsyPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/ssy-archived-acount/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyPassbookArchived />
            </Suspense>} />
            <Route path="/portfolio/bonds-debentures" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BondsAndDebentures />
            </Suspense>} />
            <Route path="/portfolio/add-bonds-debentures" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentures />
            </Suspense>} />
            <Route path="/portfolio/edit-bonds-debentures/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentures />
            </Suspense>} />
            <Route path="/portfolio/archived-bonds-debentures" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BondsAndDebenturesArchived />
            </Suspense>} />
            <Route path="/portfolio/realestate-properties" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RealEstateProperties />
            </Suspense>} />
            <Route path="/portfolio/add-realestate-properties" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRealEstate />
            </Suspense>} />
            <Route path="/portfolio/edit-realestate-properties/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRealEstate />
            </Suspense>} />
            <Route path="/portfolio/realestate-archived-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RealEstateArchivedAccounts />
            </Suspense>} />
            <Route path="/portfolio/bullion-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BullionInvestments />
            </Suspense>} />

            <Route path="/portfolio/archeived-bullion-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedBullionSip />
            </Suspense>} />
            <Route path="/portfolio/add-bullion-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBullionSip />
            </Suspense>} />
            <Route path="/portfolio/edit-bullion-sip/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBullionSip />
            </Suspense>} />

            <Route path="/portfolio/edit-bullion-investments/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditBullionInvestments />
            </Suspense>} />
            <Route path="/portfolio/add-bullion-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditBullionInvestments />
            </Suspense>} />
            <Route path="/portfolio/archived-bullion-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BullionInvestmentsArchived />
            </Suspense>} />
            <Route path="/portfolio/epf-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EpfAccount />
            </Suspense>} />
            <Route path="/portfolio/epf-archieved" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EpfArchieved />
            </Suspense>} />
            <Route path="/portfolio/add-epf-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfDetails />
            </Suspense>} />
            <Route path="/portfolio/edit-epf-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfDetails />
            </Suspense>} />
            <Route path="/portfolio/epf-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EpfPassbook />
            </Suspense>} />
            <Route path="/portfolio/add-epf-passbook-entry/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/edit-epf-passbook-entry/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFunds />
            </Suspense>} />
            <Route path="/portfolio/mutual-funds-transaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsTransactions />
            </Suspense>} />
            <Route path="/portfolio/update-mutualfunds-transaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UpdateMutualFundTransaction />
            </Suspense>} />
            <Route path="/portfolio/update-shareetf-transaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UpdateShareEtfTransaction />
            </Suspense>} />
            <Route path="/portfolio/archived-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsArchivedList />
            </Suspense>} />
            <Route path="/portfolio/mutual-funds-transaction-archived/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsTransactionsArchived />
            </Suspense>} />
            <Route path="/portfolio/mutual-fund/systematic-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SystematicInvestmentArchived />
            </Suspense>} />
            <Route path="/portfolio/add-sip-stp-swp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSipStpSwp />
            </Suspense>} />
            <Route path="/portfolio/edit-sip-stp-swp/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSipStpSwp />
            </Suspense>} />
            <Route path="/portfolio/nps-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NpsDetails />
            </Suspense>} />
            <Route path="/portfolio/add-nps-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNpsDetails />
            </Suspense>} />
            <Route path="/portfolio/edit-nps-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNpsDetails />
            </Suspense>} />
            <Route path="/portfolio/nps-details-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NpsDetailArchieved />
            </Suspense>} />
            <Route path="/portfolio/superannuation-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperannuationAcc />
            </Suspense>} />
            <Route path="/portfolio/add-superannuation-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSuperannuationDetails />
            </Suspense>} />
            <Route path="/portfolio/edit-superannuation-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSuperannuationDetails />
            </Suspense>} />
            <Route path="/portfolio/archived-superannuation-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAnnutationArchived />
            </Suspense>} />
            <Route path="/portfolio/cash-equivalents" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CashEquivalents />
            </Suspense>} />
            <Route path="/portfolio/insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsurancePortfolio />
            </Suspense>} />
            <Route path="/portfolio/shares-etf" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareETF />
            </Suspense>} />
            <Route path="/portfolio/change-dmat" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ChangeDmat />
            </Suspense>} />
            <Route path="/portfolio/holding-archived-shares-etf" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareETFHoldingArchivedList />
            </Suspense>} />
            <Route path="/portfolio/shares-etf-transaction/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareEtfTransactions />
            </Suspense>} />
            <Route path="/portfolio/shares-etf-transaction-archived/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareEtfTransactionsArchived />
            </Suspense>} />
            <Route path="/portfolio/add-share-epf-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddShareEpfSip />
            </Suspense>} />
            <Route path="/portfolio/archeived-share-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedShareSip />
            </Suspense>} />
            <Route path="/portfolio/edit-share-epf-sip/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddShareEpfSip />
            </Suspense>} />

            {/* 4) Goals Module */}

            <Route path="/goals" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Goals />
            </Suspense>} />
            <Route path="goals/add-goal" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoal />
            </Suspense>} />
            <Route path="goals/edit-goal/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoal />
            </Suspense>} />
            <Route path="goals/view-goal/:id/:disable" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoal />
            </Suspense>} />
            <Route path="goals/archeived-goal" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedGoals />
            </Suspense>} />

            {/* 5) Expense Module */}

            <Route path="/expenses" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Expenses />
            </Suspense>} />
            <Route path="/expenses-detail" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExpensesDetails />
            </Suspense>} />
            <Route path="/expenses-minimum" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExpensesMinimum />
            </Suspense>} />
            <Route path="/expenses-detail-saved" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExpensesDetailsSave />
            </Suspense>} />
            <Route path="/insurance-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceRiders />
            </Suspense>} />



            {/* 6) Insurance */}

            <Route path="/insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Insurance />
            </Suspense>} />
            <Route path="/insurance/add-insurance-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsurance />
            </Suspense>} />
            <Route path="/insurance/edit-insurance-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsurance />
            </Suspense>} />
            <Route path="/insurance/add-riders/:insurence_id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiders />
            </Suspense>} />
            <Route path="/insurance/edit-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiders />
            </Suspense>} />
            <Route path="/insurance/archived-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedRiders />
            </Suspense>} />
            <Route path="/archived-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsurance />
            </Suspense>} />
            <Route path="/future-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FutureInsurance />
            </Suspense>} />
            <Route path="/add-money-back-payout/:id/:type" element={<Suspense fallback={<><Loader show={true} /> </>} >
              <AddMoneyBackPayout />
            </Suspense>} />
            <Route path="/update-money-back-payout/:id/:type/:p_id" element={<Suspense fallback={<><Loader show={true} /> </>} >
              <AddMoneyBackPayout />
            </Suspense>} />

            {/* 7) Action */}

            <Route path="/actions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Actions />
            </Suspense>} />
            <Route path="/actions/my-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MyTask />
            </Suspense>} />
            <Route path="/actions/client-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientTask />
            </Suspense>} />
            <Route path="/actions/my-task-hibernated" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Hibernated />
            </Suspense>} />
            <Route path="/actions/my-task/edit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditTask />
            </Suspense>} />
            <Route path="/actions/assign-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssignTask />
            </Suspense>} />
            <Route path="/actions/recurring" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Recurring />
            </Suspense>} />
            <Route path="/actions/archived-recurring" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedRecurring />
            </Suspense>} />
            <Route path="/actions/my-action-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMyTask />
            </Suspense>} />
            <Route path="/actions/add-recurring" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRecurring />
            </Suspense>} />
            <Route path="/actions/edit-recurring/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRecurring />
            </Suspense>} />
            <Route path="/actions/document-tracker" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DocumentTracker />
            </Suspense>} />
            <Route path="/actions/add-document-tracker" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentTracker />
            </Suspense>} />
            <Route path="/actions/edit-document-tracker/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentTracker />
            </Suspense>} />
            <Route path="/actions/archived-document-tracker" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedDocumentTracker />
            </Suspense>} />

            <Route path="/actions/manager" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Manager />
            </Suspense>} />
            <Route path="/actions/unassign-manager" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UnassignedManager />
            </Suspense>} />
            <Route path="/actions/reassign-manager" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReassignManager />
            </Suspense>} />
            <Route path="/action/my-document" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MyDocuments />
            </Suspense>} />
            <Route path="/action/add-document" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocument />
            </Suspense>} />
            <Route path="/action/edit-document/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocument />
            </Suspense>} />
            <Route path="/action/archived-document" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedDocument />
            </Suspense>} />
            <Route path="/action/view-edit-document/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocument />
            </Suspense>} />
            <Route path="/raise/advice/request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RaiseAdviceRequest />
            </Suspense>} />
            <Route path="/raise/advice/add-client-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientAdviceRequest />
            </Suspense>} />
            <Route path="/raise/advice/archeived-client-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedClientAdviceRequest />
            </Suspense>} />
            <Route path="/raise/advice/edit-Lum-sum_investment-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditLumSumInvestment />
            </Suspense>} />
            <Route path="/raise/advice/edit-Sip_investment-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSipInvestment />
            </Suspense>} />
            <Route path="/raise/advice/edit-redemption-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditRedemption />
            </Suspense>} />
            <Route path="/raise/advice/edit-Sip_Cancellation-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSipCancellation />
            </Suspense>} />
            <Route path="/raise/advice/edit-Sip_Pause-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSipPause />
            </Suspense>} />

            {/*  */}
            <Route path="/actions/add-action" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/actions/edit-action/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/actions/edit-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/action/view-edit-action/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/action/view-edit-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/actions/archived-assigned-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAssignTask />
            </Suspense>} />
            <Route path="/actions/my-action-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMyTask />
            </Suspense>} />
            {/*  */}

            <Route path="/action/minutes-of-meeting" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MinutesOfMeeting />
            </Suspense>} />
            <Route path="/action/received-for-review" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReceivedForReview />
            </Suspense>} />
            <Route path="/action/add-minutes-of-meeting" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMoM />
            </Suspense>} />
            <Route path="/action/edit-minutes-of-meeting/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMoM />
            </Suspense>} />
            <Route path="/actions/mom-sentfor-review" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MomSentForReview />
            </Suspense>} />

            {/* 8) MIS Report */}

            <Route path="/reports/transaction-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TransactionReport />
            </Suspense>} />
            <Route path="/reports" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Reports />
            </Suspense>} />
            <Route path="/reports/capital-gain-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CapitalGainReport />
            </Suspense>} />
            <Route path="/reports/notional-capital-gain-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NotionalCapitalGainReport/>
            </Suspense>} />
            <Route path="/reports/tax" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Tax />
            </Suspense>} />
            <Route path="/reports/paid-invoices" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PaidInvoicesReport />
            </Suspense>} />
            <Route path="/reports/tax-calculation-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxCalculationReport />
            </Suspense>} />
            <Route path="/reports/tax-calculation-old-regime-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxCalculationReportOldRegim />
            </Suspense>} />
            <Route path="/reports/holding-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HoldingReport />
            </Suspense>} />
            <Route path="/reports/invoices" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvoicesReport />
            </Suspense>} />
            <Route path="/reports/cash-flow" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReportExpectedCashFlow />
            </Suspense>} />


            <Route path="/report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanReport />
            </Suspense>} />



            {/* ADMIN */}

            {/* 1)  Accouting */}

            <Route path="/accouting/expense-voucher" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExpenseVoucher />
            </Suspense>} />
            <Route path="/accouting/add-expense-vouchers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddExpenseVouchers />
            </Suspense>} />
            <Route path="/accouting/edit-expense-vouchers/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddExpenseVouchers />
            </Suspense>} />
            <Route path="/accouting/export-to-excel" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExportToExcel />
            </Suspense>} />
            <Route path="/accouting/upload-invoice-bill/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UploadInvoiceBill />
            </Suspense>} />
            <Route path="/vendorsupplier/vendor-supplier" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <VendorSuppliers />
            </Suspense>} />
            <Route path="/vendorsupplier/add-vendor-supplier" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddVendorSupplier />
            </Suspense>} />
            <Route path="/vendorsupplier/edit-vendor-supplier/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddVendorSupplier />
            </Suspense>} />
            <Route path="/vendorsupplier/archived-vendor-supplier" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedVendorsSuppliers />
            </Suspense>} />
            <Route path="/accounting/aua-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuaCalculation />
            </Suspense>} />
            <Route path="/accounting/client-address" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientInvoiceAddress />
            </Suspense>} />
            <Route path="/accounting/edit-client-address/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditClientInvoiceAddress />
            </Suspense>} />
            <Route path="/accounting/invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Invoice />
            </Suspense>} />
            <Route path="/accounting/add-invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvoice />
            </Suspense>} />
            <Route path="/accounting/edit-invoice/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvoice />
            </Suspense>} />
            <Route path="/accounting/export-income-to-excel" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExportIncomeToExcel />
            </Suspense>} />
            <Route path="/accounting/archived-invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Cancelled />
            </Suspense>} />
            <Route path="/accounting/submitted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Submitted />
            </Suspense>} />
            <Route path="/accounting/paid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Paid />
            </Suspense>} />
            <Route path="/accounting/company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompnayBankAccount />
            </Suspense>} />
            <Route path="/accounting/add-company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyBankAccount />
            </Suspense>} />
            <Route path="/accounting/edit-company-bank-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyBankAccount />
            </Suspense>} />

            <Route path="/accounting/company-bank-account-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompBankAccountPassbook />
            </Suspense>} />
            <Route path="/accounting/add-company-bank-account-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompBankPassbookEntry />
            </Suspense>} />
            <Route path="/accounting/edit-company-bank-account-passbook/:id/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompBankPassbookEntry />
            </Suspense>} />
            <Route path="/accounting/view-company-bank-account-passbook/:id/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompBankPassbookEntry />
            </Suspense>} />
            <Route path="/accounting/import-bank-passbook" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImportBankPassbookDetails />
            </Suspense>} />
            <Route path="/accounting/archived-company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCompanyBankAccount />
            </Suspense>} />
            <Route path="/accouting/fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FeeMandates />
            </Suspense>} />
            <Route path="/accouting/add-fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFeeMandates />
            </Suspense>} />
            <Route path="/accouting/edit-fee-mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFeeMandates />
            </Suspense>} />
            <Route path="/accouting/archived-fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFeeMandates />
            </Suspense>} />

            <Route path="/advice-request/" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceRequest />
            </Suspense>} />
            <Route path="/add-advice-request/" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAdviceRequest />
            </Suspense>} />
            {/* <Route path="/admin/dashboard/" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminDashboard />
            </Suspense>} /> */}

            {/* \) Masters */}

            <Route path="/clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Clients />
            </Suspense>} />
            <Route path="/admin/draft-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DraftClients />
            </Suspense>} />
            <Route path='/clients/add-clients/personal-details' element={<Suspense fallback={<><Loader show={true} /></>}>
              <AddNewClient />
            </Suspense>} />
            <Route path='/clients/add-clients/personal-details/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <AddNewClient />
            </Suspense>} />
            <Route path='/clients/add-clients/contract-details/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <ContractDetails />
            </Suspense>} />
            <Route path='/clients/add-clients/onboarding-checklist/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <Onboarding />
            </Suspense>} />
            <Route path='/clients/pan-varification' element={<Suspense fallback={<><Loader show={true} /></>}>
              <PanVarification />
            </Suspense>} />
            <Route path='/clients/add-clients/Menu-Selection/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <MenuSelection />
            </Suspense>} />
            <Route path='/clients/add-clients/cis-details/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <ClientCisDetails />
            </Suspense>} />
            <Route path='/clients/add-clients/mail-group/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <MailGroup />
            </Suspense>} />
            <Route path="/add-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClients />
            </Suspense>} />
            <Route path="/edit-clients/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClients />
            </Suspense>} />
            <Route path="/archived-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClients />
            </Suspense>} />
            <Route path="/subscribed-services/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientSubscribedServices />
            </Suspense>} />
            <Route path="/Archived-Subscribed-services/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientArchivedSubscribedServices />
            </Suspense>} />
            <Route path="/add-new-services/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNewServices />
            </Suspense>} />
            <Route path="/edit-new-services/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNewServices />
            </Suspense>} />
            <Route path="/advisor-goals" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdvisorGoals />
            </Suspense>} />
            <Route path="/slabs" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Slabs />
            </Suspense>} />
            <Route path="/archived-slabs" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedSlabs />
            </Suspense>} />
            <Route path="/add-slabs" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSlab />
            </Suspense>} />
            <Route path="/edit-slab/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSlab />
            </Suspense>} />
            <Route path="/master/announcements" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Announcements />
            </Suspense>} />
            <Route path="/master/archived-announcements" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAnnouncements />
            </Suspense>} />
            <Route path="/master/add-announcements" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnouncements />
            </Suspense>} />
            <Route path="/master/edit-announcements/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnouncements />
            </Suspense>} />
            <Route path="/master/planning-assumption" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Assumptions />
            </Suspense>} />
            <Route path="/master/planning-edit-assumption/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditAssumption />
            </Suspense>} />
            <Route path="/master/planning-model-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-add-model-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-edit-model-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-view-edit-model-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-view-model-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ViewModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Comments />
            </Suspense>} />
            <Route path="/master/planning-add-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddComments />
            </Suspense>} />
            <Route path="/master/planning-edit-comments/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddComments />
            </Suspense>} />
            <Route path="/master/planning-archived-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedComments />
            </Suspense>} />
            <Route path="/master/planning-disclaimer-discloser" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DisclaimerAndDiscloser />
            </Suspense>} />
            <Route path="/master/planning-edit-disclaimer-discloser/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditDisclaimerAndDiscloser />
            </Suspense>} />
            <Route path="/master/planning-mailing-group" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MalingGroups />
            </Suspense>} />
            <Route path="/master/archived-planning-mailing-group" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMailingGroup />
            </Suspense>} />
            <Route path="/master/planning-add-mailing-group" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailingGroup />
            </Suspense>} />
            <Route path="/master/planning-edit-mailing-group/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailingGroup />
            </Suspense>} />
            <Route path="/master/planning-group-user-of/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GroupsUserOf />
            </Suspense>} />
            <Route path="/master/planning-send-mail-to-group/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SendMailtoGroup />
            </Suspense>} />
            <Route path="/master/planning-add-group-user-of/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGroupUser />
            </Suspense>} />
            <Route path="/master/global-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GlobalParameter />
            </Suspense>} />
            <Route path="/master/edit-global-parameter/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditGlobalParameter />
            </Suspense>} />
            <Route path="/master/archived-global-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedModelPortfolios />
            </Suspense>} />
            <Route path="/master/edit-global-parameter-fee-structure/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditGlobalParameterFeeStructure />
            </Suspense>} />
            <Route path="/master/master-company-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MasterCompanyMaster />
            </Suspense>} />
            <Route path="/master/master-business-accreditation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BusinessAccreditation />
            </Suspense>} />
            <Route path="/master/master-archived-business-accreditation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedBusinessAccreditation />
            </Suspense>} />
            <Route path="/master/masters-add-business-accreditation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBusinessAccreditation />
            </Suspense>} />
            <Route path="/master/masters-edit-business-accreditation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBusinessAccreditation />
            </Suspense>} />
            <Route path="/master/company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompanyBankAccounts />
            </Suspense>} />
            <Route path="/master/edit-company-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditCompanyDetails />
            </Suspense>} />
            <Route path="/master/branches" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Branches />
            </Suspense>} />
            <Route path="/master/add-branches" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBranches />
            </Suspense>} />
            <Route path="/master/edit-branches/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBranches />
            </Suspense>} />
            <Route path="/master/archived-branches" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedBranches />
            </Suspense>} />
            <Route path="/master/planning-sign-off-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompanySignOffDetails />
            </Suspense>} />
            <Route path="/master/planning-edit-sign-off-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditCompanySignOffDetails />
            </Suspense>} />
            <Route path="/master/insurance-product-recommendation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceProductRecommendations />
            </Suspense>} />
            <Route path="/master/mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MailTemplates />
            </Suspense>} />
            <Route path="/master/create-new-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateNewTemplate />
            </Suspense>} />
            <Route path="/master/edit-new-template/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateNewTemplate />
            </Suspense>} />
            <Route path="/master/view-new-template/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateNewTemplate />
            </Suspense>} />
            <Route path="/master/archived-mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMailTemplates />
            </Suspense>} />
            <Route path="/master/copy-record-from-master-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CopyRecordFromMasterTemplate />
            </Suspense>} />
            <Route path="/master/recommendation-investment-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentProduct />
            </Suspense>} />
            <Route path="/master/add-recommendation-investment-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentProduct />
            </Suspense>} />
            <Route path="/master/edit-recommendation-investment-product/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentProduct />
            </Suspense>} />
            <Route path="/master/view-edit-recommendation-investment-product/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentProduct />
            </Suspense>} />
            <Route path="/master/archived-recommendation-investment-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInvestmentProduct />
            </Suspense>} />
            <Route path="/master/desired-asset-allocation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DesiredAssetAllocation />
            </Suspense>} />
            <Route path="/master/archeived-desired-asset-allocation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedDesiredAssetAllocation />
            </Suspense>} />
            <Route path="/master/add-desired-asset-allocation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDesiredAssetAllocation />
            </Suspense>} />
            <Route path="/master/Client-Menu-Selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientMenuSelection />
            </Suspense>} />
            <Route path="/master/add-Client-Menu-Selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMenuSelection />
            </Suspense>} />
            <Route path="/master/edit-Client-Menu-Selection/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMenuSelection />
            </Suspense>} />

            {/* HR */}

            <Route path="/admin/employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Employees />
            </Suspense>} />
            <Route path="/admin/add-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployee />
            </Suspense>} />
            <Route path="/admin/add-employees/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployee />
            </Suspense>} />
            <Route path="/admin/onboard-employees/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeeOnboarding />
            </Suspense>} />
            <Route path="/admin/employee-menu/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeeMenu />
            </Suspense>} />
            <Route path="/Employee-menu-selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeeMenuSelection />
            </Suspense>} />
            <Route path="/add-employee-menu-selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployeeMenuSelection />
            </Suspense>} />
            <Route path="/edit-employee-menu-selection/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployeeMenuSelection />
            </Suspense>} />
            <Route path="/admin/edit-employees/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditEmployee />
            </Suspense>} />
            <Route path="/admin/archived-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEmployees />
            </Suspense>} />
            <Route path="/admin/draft-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DraftEmployees />
            </Suspense>} />
            <Route path="/admin/employee-entry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeesEntry />
            </Suspense>} />
            <Route path="/admin/edit-employee-entry/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditEmployeeEntry />
            </Suspense>} />
            <Route path="/archivedEmployeeEntry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEmployeeEntry />
            </Suspense>} />
            <Route path="/admin/employee-exit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeesExit />
            </Suspense>} />
            <Route path="/admin/edit-employee-exit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditEmployeeExit />
            </Suspense>} />
            <Route path="/archivedEmployeeExit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEmployeeExit />
            </Suspense>} />
            <Route path="/admin/leave-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LeaveType />
            </Suspense>} />
            <Route path="/admin/add-leave-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLeaveType />
            </Suspense>} />
            <Route path="/admin/edit-leave-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLeaveType />
            </Suspense>} />
            <Route path="/admin/holiday-calender" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HolidayCalender />
            </Suspense>} />
            <Route path="/add-holiday" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHoliday />
            </Suspense>} />
            <Route path="/edit-holiday/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHoliday />
            </Suspense>} />
            {/* <Route path="/admin/holiday-calender-emplyoee" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HolidayCalenderForEmplyoee />
            </Suspense>} /> */}


            {/* Aua  Selection */}

            <Route path="/admin/aua-selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuaSelection />
            </Suspense>} />
            <Route path="/admin/edit-aua-selection/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditAuaSelection />
            </Suspense>} />

            {/* Mis Report */}
            <Route path="/mis-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisReport />
            </Suspense>} />
            <Route path="/admin/80C-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EightyCReport />
            </Suspense>} />
            <Route path="/admin/mutual-fund-rta-codes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundRtaCodes />
            </Suspense>} />
            <Route path="/admin/archived-mutual-fund-rta-codes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMutualFundRtaCodes />
            </Suspense>} />
            <Route path="/admin/mf-holding-scheme-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MFHoldingsSchemeWise />
            </Suspense>} />
            <Route path="/admin/share-holding-company-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesHoldingCompanyWise />
            </Suspense>} />
            <Route path="/admin/share-holding-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareHoldingClientWise />
            </Suspense>} />
            <Route path="/admin/archived-subscribed-services" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedSubscribedServices />
            </Suspense>} />
            <Route path="/admin/insurance-renewals" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceRenewal />
            </Suspense>} />
            <Route path="/admin/maturity-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MaturityInvestments />
            </Suspense>} />
            <Route path="/admin/investment-Account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentAccount />
            </Suspense>} />
            <Route path="/admin/share-isin" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareIsin />
            </Suspense>} />
            <Route path="/admin/risk-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfileMisReport />
            </Suspense>} />
            <Route path="/admin/systematic-plans-all-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SystematicsPlansAllClients />
            </Suspense>} />
            <Route path="/admin/mf-transaction-all-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionReportAllClient />
            </Suspense>} />
            <Route path="/admin/share-transaction-all-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionReportAllClient />
            </Suspense>} />
            <Route path="/admin/systematic-investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SystematicInvestments />
            </Suspense>} />
            <Route path="/admin/advice-log-book" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBook />
            </Suspense>} />
            <Route path="/admin/advice-log-book/Archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookArchived />
            </Suspense>} />
            <Route path="/admin/advice-log-book-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookAdd />
            </Suspense>} />
            <Route path="/admin/advice-log-book-add/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookAdd />
            </Suspense>} />
            <Route path="/admin/advice-transaction/:id/:advice_id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceTransaction />
            </Suspense>} />
            <Route path="/admin/action-plan-log" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ActionPlanLog />
            </Suspense>} />
            <Route path="/admin/mf-holding-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfHoldingClientWise />
            </Suspense>} />
            <Route path="/admin/action-client's-tasks" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientActionTask />
            </Suspense>} />
            <Route path="/admin/admin-holding-report-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminHoldingReport />
            </Suspense>} />
            {/* <Route path="/admin-aua-report-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuAReport />
            </Suspense>} /> */}
            <Route path="/admin-aua-report-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuAReportGrid />
            </Suspense>} />
            <Route path="/admin/mis-report/agreement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Agreement />
            </Suspense>} />
            <Route path="/admin/mis-report/add-agreement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/create-agreement/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/edit-agreement/:id/:p_id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/renew-agreement/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/archived-agreement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/upload-agreement/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AgreementUploadDocument />
            </Suspense>} />
            <Route path="/admin/fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisFeeMandates />
            </Suspense>} />


            {/* {Operations} */}

            <Route path="/admin/operation/unit-reconciliation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliation />
            </Suspense>} />
            <Route path="/admin/operation/unit-reconciliation-unmatched" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliationUnmatch />
            </Suspense>} />
            <Route path="/admin/operation/unit-reconciliation-in-system" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliationInSystem />
            </Suspense>} />
            <Route path="/admin/operation/unit-reconciliation-not-rta" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliationNotRta />
            </Suspense>} />
            <Route path="/admin/operation/import-unit-reconciliation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImportUnitReconciliation />
            </Suspense>} />
            <Route path="/operations/fixed/income/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedIncomeTransactions />
            </Suspense>} />
            <Route path="/operations/files_upload" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FilesUpload />
            </Suspense>} />
            <Route path="/operations/share/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactions />
            </Suspense>} />
            <Route path="/operations/share/systematic/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareSystematicTransactions />
            </Suspense>} />
            <Route path="/operations/share/archived-transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsArchived />
            </Suspense>} />
            <Route path="/operations/share/transaction/future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsFuture />
            </Suspense>} />
            <Route path="/operations/share/transaction/platform" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsPlatform />
            </Suspense>} />
            <Route path="/operations/share/transaction/archived-sips" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedSips />
            </Suspense>} />
            <Route path="/operations/share/transaction/inProcess" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionInProcess />
            </Suspense>} />
            <Route path="/operations/share/transaction/error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionError />
            </Suspense>} />
            <Route path="/operations/share/transaction/ready" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsReady />
            </Suspense>} />
            <Route path="/operations/share/transaction/platform/import" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsImport />
            </Suspense>} />
            <Route path="/operations/mf/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactions />
            </Suspense>} />
            <Route path="/operations/mf/transaction/platform" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsPlatform />
            </Suspense>} />
            <Route path="/operations/mf/transaction/future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsFuture />
            </Suspense>} />
            <Route path="/operations/mf/transaction/transactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsTransactions />
            </Suspense>} />
            <Route path="/operations/mf/transaction/error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsError />
            </Suspense>} />
            <Route path="/operations/mf/transaction/ready" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsReady />
            </Suspense>} />
            <Route path="/operations/mf/transaction/archive" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsArchive />
            </Suspense>} />
            <Route path="/operations/mf/transaction/archived-mf-transactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsArchived />
            </Suspense>} />
            <Route path="/operation/mf/import-transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionImport />
            </Suspense>} />
            <Route path="/operations/mf/systematic/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicTransactions />
            </Suspense>} />
            <Route path="/operations/mf/systematic/archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicArchived />
            </Suspense>} />
            <Route path="/operations/mf/systematic/error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicError />
            </Suspense>} />
            <Route path="/operations/mf/systematic/ready" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicReady />
            </Suspense>} />
            <Route path="/operations/mf/systematic/transactiontab" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicTransactiontab />
            </Suspense>} />
            <Route path="/operations/mf/systematic/future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicFuture />
            </Suspense>} />
            <Route path="/operations/mf/systematic/platform" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicPlatform />
            </Suspense>} />
            <Route path="/operation/mf-systematic/import-transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicPlatformImport />
            </Suspense>} />
            <Route path="/operations/mf/systematic/paused" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicPaused />
            </Suspense>} />
            <Route path="/operations/mf/systematic/import" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicImport />
            </Suspense>} />
            <Route path="/operations/mf-systematic/archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSysArchived />
            </Suspense>} />

            <Route path="/operations/client/information" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CisDetails />
            </Suspense>} />
            <Route path="/operations/archeived-client/information" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedCisDetails />
            </Suspense>} />
            <Route path="/operations/edit-client/information/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditCisDetails />
            </Suspense>} />
            <Route path="/operations/client/entry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientEntry />
            </Suspense>} />
            <Route path="/archivedClientsEntry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientsEntry />
            </Suspense>} />
            <Route path="/operations/client/exit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientExit />
            </Suspense>} />
            <Route path="/archivedClientClearance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientExit />
            </Suspense>} />
            <Route path="/admin/edit-client-exit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditClientExit />
            </Suspense>} />
            <Route path="/admin/edit-client-entry/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditClientEntry />
            </Suspense>} />
            <Route path="/operations/account-opening-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Mandates />
            </Suspense>} />
            <Route path="/mandates/add-account-mandate" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMandates />
            </Suspense>} />
            <Route path="/mandates/edit-account-mandate/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMandates />
            </Suspense>} />
            <Route path="/mandates/archived-account-mandate" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMandates />
            </Suspense>} />
            

            {/* Super Admin */}

            {/* Product Master */}

            <Route path="/information/product-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductCategories />
            </Suspense>} />
            <Route path="/information/archived-product-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedProductCategories />
            </Suspense>} />
            <Route path="/information/add-product-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddProductCategories />
            </Suspense>} />
            <Route path="/information/edit-product-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddProductCategories />
            </Suspense>} />
            <Route path="/information/edit-product-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddProductCategories />
            </Suspense>} />
            <Route path="/product-master/client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientPortfolio />
            </Suspense>} />
            <Route path="/product-master/add-client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientPortfolio />
            </Suspense>} />
            <Route path="/product-master/edit-client-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientPortfolio />
            </Suspense>} />
            <Route path="/product-master/archived-client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientPortfolio />
            </Suspense>} />

            {/* Mis Report */}
            <Route path="/mis-report/Advisor-aua" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdvisorsAua />
            </Suspense>} />
            <Route path="/mis-report/signzy-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SignzyReport />
            </Suspense>} />
            <Route path="/mis-report/shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisShares />
            </Suspense>} />
            <Route path="/mis-report/mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisMutualFunds />
            </Suspense>} />
            <Route path="/mis-report/agreement-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AgreementReport />
            </Suspense>} />


            {/* Help */}

            <Route path="/sa-help-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HelpMaster />
            </Suspense>} />
            <Route path="/sa-client-help-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientHelpMaster />
            </Suspense>} />
            <Route path="/sa-financial-planning-help-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningHelpMaster />
            </Suspense>} />

            {/* Document Master */}

            <Route path="/sa-upload-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DocumentMaster />
            </Suspense>} />
            <Route path="/add-upload-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentMaster />
            </Suspense>} />
            <Route path="/actions/edit-document-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentMaster />
            </Suspense>} />
            <Route path="/archived-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedDocumentsMaster />
            </Suspense>} />


            {/* Insurance */}

            <Route path="/insurance/types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/add-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/edit-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/archived-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/subTypes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/add-subTypes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/edit-subTypes/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/archived-subTypes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/benifits-available" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BenefitsAvailable />
            </Suspense>} />
            <Route path="/insurance/add-benifits-available" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBenifitsAvailable />
            </Suspense>} />
            <Route path="/insurance/edit-benifits-available/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBenifitsAvailable />
            </Suspense>} />
            <Route path="/insurance/archived-benifits-available" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedBenefitsAvailable />
            </Suspense>} />
            <Route path="/insurance/natureof-policy" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/add-natureof-policy" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/edit-natureof-policy/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/archived-natureof-policy" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedNatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/riders" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Riders />
            </Suspense>} />
            <Route path="/insurance/add-insurance-riders" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceRiders />
            </Suspense>} />
            <Route path="/insurance/edit-insurance-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceRiders />
            </Suspense>} />
            <Route path="/insurance/archived-insurance-riders" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceRiders />
            </Suspense>} />

            <Route path="/insurance/categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/add-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/edit-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/archived-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/annuity-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AnnuityTypes />
            </Suspense>} />
            <Route path="/insurance/add-annuity-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnuityTypes />
            </Suspense>} />
            <Route path="/insurance/edit-annuity-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnuityTypes />
            </Suspense>} />
            <Route path="/insurance/archived-annuity-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAnnuityTypes />
            </Suspense>} />

            {/* Transaction Type */}

            <Route path="/insurance/transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TransactionType />
            </Suspense>} />
            <Route path="/insurance/archived-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedTransactionType />
            </Suspense>} />
            <Route path="/insurance/add-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTransactionType />
            </Suspense>} />
            <Route path="/insurance/edit-transactions-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTransactionType />
            </Suspense>} />
            {/* Operation Transaction Type Master  */}
            <Route path="/operationTransactionTypeMaster/transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OperationTransactionTypeMaster />
            </Suspense>} />
            <Route path="/operation-Transaction-Type-Master/add-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOperationTransactionType />
            </Suspense>} />
            <Route path="/operation-Transaction-Type-Master/edit-transactions-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOperationTransactionType />
            </Suspense>} />
            <Route path="/operation-Transaction-Type-Master/archived-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedOperationTransactionType />
            </Suspense>} />

            {/* Mutual Funds */}

            <Route path="/mutualfunds/taxaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Taxaction />
            </Suspense>} />
            <Route path="/mutualfunds/archived-taxaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedTaxaction />
            </Suspense>} />
            <Route path="/mutualfunds/add-taxaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaxaction />
            </Suspense>} />
            <Route path="/mutualfunds/edit-taxaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaxaction />
            </Suspense>} />
            <Route path="/mutualfunds/categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/add-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/edit-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/archived-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/sub-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsSubCategories />
            </Suspense>} />
            <Route path="/mutualfunds/add-sub-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsSubCategories />
            </Suspense>} />
            <Route path="/mutualfunds/edit-sub-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsSubCategories />
            </Suspense>} />
            <Route path="/mutualfunds/archived-sub-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMutualFundsSubCategories />
            </Suspense>} />

            {/* Share Master */}

            {/* Market Cap */}
            <Route path="/share-master/market-cap" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} />
            <Route path="/share-master/add-market-cap" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapAdd />
            </Suspense>} />
            <Route path="/share-master/edit-market-cap/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapAdd />
            </Suspense>} />
            <Route path="/share-master/market-cap-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapArchived />
            </Suspense>} />

            {/* Product Type */}
            <Route path="/share-master/share-product-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeMaster />
            </Suspense>} />
            <Route path="/share-master/add-product-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeAdd />
            </Suspense>} />
            <Route path="/share-master/edit-product-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeAdd />
            </Suspense>} />
            <Route path="/share-master/product-type-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeArchived />
            </Suspense>} />

            {/* Asset Class */}
            <Route path="/share-master/asset-class" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassMaster />
            </Suspense>} />
            <Route path="/share-master/add-asset-class" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassAdd />
            </Suspense>} />
            <Route path="/share-master/edit-asset-class/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassAdd />
            </Suspense>} />
            <Route path="/share-master/asset-class-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassArchived />
            </Suspense>} />

            {/* Industry */}
            {/* <Route path="/share-master/industry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryMaster />
            </Suspense>} />
            <Route path="/share-master/add-industry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryAdd />
            </Suspense>} />
            <Route path="/share-master/edit-industry/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryAdd />
            </Suspense>} />
            <Route path="/share-master/industry-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryArchived />
            </Suspense>} /> */}

            {/* Sector */}
            {/* <Route path="/share-master/sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorMaster />
            </Suspense>} />
            <Route path="/share-master/add-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorAdd />
            </Suspense>} />
            <Route path="/share-master/edit-sector/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorAdd />
            </Suspense>} />
            <Route path="/share-master/sector-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorArchived />
            </Suspense>} /> */}

            {/* Main Sector */}
            {/* <Route path="/share-master/main-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* Sub Sector */}
            {/* <Route path="/share-master/sub-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* Micro Sector */}
            {/* <Route path="/share-master/micro-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* Product/Services */}
            {/* <Route path="/share-master/product-services" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* MOAT */}
            {/* <Route path="/share-master/moat-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* Model */}
            {/* <Route path="/share-master/share-model" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* Cycle */}
            {/* <Route path="/share-master/cycle" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* Profile */}
            {/* <Route path="/share-master/share-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} /> */}

            {/* Income */}

            <Route path="/income/income-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncomeCategories />
            </Suspense>} />
            <Route path="/income/archived-income-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedIncomeCategories />
            </Suspense>} />
            <Route path="/income/add-income-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeCategories />
            </Suspense>} />
            <Route path="/income/edit-income-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeCategories />
            </Suspense>} />
            <Route path="/income/income-heads" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncomeHeads />
            </Suspense>} />
            <Route path="/income/archived-income-heads" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedIncomeHeads />
            </Suspense>} />
            <Route path="/income/add-income-heads" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeHeads />
            </Suspense>} />
            <Route path="/income/edit-income-heads/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeHeads />
            </Suspense>} />

            {/* Income */}


            {/* {Ulip Funds} */}

            <Route path="/product-master/ulip-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UlipFunds />
            </Suspense>} />
            <Route path="/product-master/archived-ulip-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedUlipFunds />
            </Suspense>} />
            <Route path="/product-master/add-ulip-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddUlipFunds />
            </Suspense>} />
            <Route path="/product-master/edit-ulip-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddUlipFunds />
            </Suspense>} />

            {/* Bonds & Debenture Funds */}

            <Route path="/bonds-debenture" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BondsAndDebentureFunds />
            </Suspense>} />
            <Route path="/archived-bonds-debenture" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedBondsAndDebentureFunds />
            </Suspense>} />
            <Route path="/add-bonds-debenture" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentureFunds />
            </Suspense>} />
            <Route path="/edit-bonds-debenture/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentureFunds />
            </Suspense>} />

            {/* Real Estate */}

            <Route path="/realstate/ownership-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OwnershipStatus />
            </Suspense>} />
            <Route path="/realstate/archived-ownership-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedOwnershipStatus />
            </Suspense>} />
            <Route path="/realestate/add-ownership-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOwnershipStatus />
            </Suspense>} />
            <Route path="/realestate/edit-ownership-status/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOwnershipStatus />
            </Suspense>} />
            <Route path="/realstate/property-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PropertyType />
            </Suspense>} />
            <Route path="/realstate/archived-property-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedPropertyType />
            </Suspense>} />
            <Route path="/realstate/add-property-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPropertyType />
            </Suspense>} />
            <Route path="/realstate/edit-property-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPropertyType />
            </Suspense>} />

            {/* Household */}

            <Route path="/household/household-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdCategories />
            </Suspense>} />
            <Route path="/household/archived-household-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SAArchivedHouseholdCategories />
            </Suspense>} />
            <Route path="/household/add-household-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdCategories />
            </Suspense>} />
            <Route path="/household/edit-household-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdCategories />
            </Suspense>} />
            <Route path="/household/household-assets" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdAssets />
            </Suspense>} />
            <Route path="/household/archived-household-assets" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedHouseholdAsset />
            </Suspense>} />
            <Route path="/household/add-household-assets" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdAssets />
            </Suspense>} />
            <Route path="/household/edit-household-assets/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdAssets />
            </Suspense>} />
            <Route path="/household/household-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdVehicles />
            </Suspense>} />
            <Route path="/household/add-household-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdVehicles />
            </Suspense>} />
            <Route path="/household/edit-household-vehicles/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdVehicles />
            </Suspense>} />

            {/*Bank */}

            <Route path="/bank/loan-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  > <LoanTypes />
            </Suspense>} />
            <Route path="/bank/archived-loan-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedLoanTypes />
            </Suspense>} />
            <Route path="/bank/add-loan-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoanTypes />
            </Suspense>} />
            <Route path="/bank/edit-loan-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoanTypes />
            </Suspense>} />

            {/*Global Product parameters */}

            <Route path="/product-master/global-product-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GlobalProductParameters />
            </Suspense>} />
            <Route path="/product-master/archived-global-product-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedGlobalProductParameters />
            </Suspense>} />
            <Route path="/product-master/add-global-product-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGlobalProductParameters />
            </Suspense>} />
            <Route path="/product-master/edit-global-product-parameter/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGlobalProductParameters />
            </Suspense>} />


            {/*Establishment*/}

            <Route path="/establishment/establishment-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/add-establishment-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/insurance-companies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/archived-insurance-companies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/add-insurance-companies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/edit-insurance-companies/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/establishment-bank" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-bank" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/add-establishment-bank" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-bank/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/establishment-branch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-branch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/add-establishment-branch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-branch/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/establishment-financial-institution" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/add-establishment-financial-institution" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-financial-institution/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-financial-institution" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/establishment-depository-participants" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-depository-participants" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/add-establishment-depository-participants" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-depository-participants/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/mutual-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentMutualFunds />
            </Suspense>} />
            <Route path="/establishment/archived-mutual-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentMutualFund />
            </Suspense>} />
            <Route path="/establishment/add-mutual-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentMutualFunds />
            </Suspense>} />
            <Route path="/establishment/edit-mutual-fund/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentMutualFunds />
            </Suspense>} />
            <Route path="/establishment/p2p-lending" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <P2pLendingMaster />
            </Suspense>} />
            <Route path="/establishment/add-p2p-lending" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddP2pLendingMaster />
            </Suspense>} />
            <Route path="/establishment/edit-p2p-lending/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddP2pLendingMaster />
            </Suspense>} />
            <Route path="/establishment/archived-p2p-lending" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedP2pLendingMaster />
            </Suspense>} />


            {/* Product Parameters */}

            {/* <Route path="/product-parameter/fixed-return-&-retirement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnAndRetirementProducts />
            </Suspense>} /> */}
            <Route path="/product-parameter/insurance-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/add-insurance-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/edit-insurance-product/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/archived-insurance-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAdminMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/archived-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAdminArchivedMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/add-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/edit-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/nav-history-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundNavHistory />
            </Suspense>} />
            <Route path="/product-parameter/add-nav-history-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundNavHistory />
            </Suspense>} />
            <Route path="/product-parameter/quantitative-indicators-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundQuantitativeIndicators />
            </Suspense>} />
            <Route path="/product-parameter/add-quantitative-indicators-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundQuantitativeIndicators />
            </Suspense>} />
            <Route path="/product-parameter/shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAdminShares />
            </Suspense>} />
            <Route path="/product-parameter/archived-shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedShares />
            </Suspense>} />
            <Route path="/product-parameter/add-shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSharesCompany />
            </Suspense>} />
            <Route path="/product-parameter/edit-shares/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSharesCompany />
            </Suspense>} />
            <Route path="/product-parameter/shares-history-Price/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesPriceHistory />
            </Suspense>} />
            <Route path="/product-parameter/add-shares-history-Price/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSharesPriceHistory />
            </Suspense>} />
            <Route path="/product-parameter/edit-shares-history-Price/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSharesPriceHistory />
            </Suspense>} />
            <Route path="/product-parameter/shares-quaterly-historic/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <QuaterlyHistoricData />
            </Suspense>} />
            <Route path="/product-parameter/add-shares-quaterly-historic/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddQuaterlyHistoricData />
            </Suspense>} />
            <Route path="/Product-parameters/Fixed-return-and-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnandRetirementProducts />
            </Suspense>} />
            <Route path="/Product-parameters/add-fixed-return-and-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturnandRetirementProducts />
            </Suspense>} />
            <Route path="/Product-parameters/edit-fixed-return-and-retirement-products/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturnandRetirementProducts />
            </Suspense>} />
            <Route path="/Product-parameters/archived-fixed-return-and-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFixedReturnandRetirementProducts />
            </Suspense>} />


            {/* Advisor Goal Master */}

            <Route path="/goalliablities/goal-liablities" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalLiablities />
            </Suspense>} />
            <Route path="/goalliablities/add-goal-liablities" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoalLiablities />
            </Suspense>} />
            <Route path="/goalliablities/edit-goal-liablities/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoalLiablities />
            </Suspense>} />
            <Route path="/goalliablities/archived-goal-liablities" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedGoalLiablities />
            </Suspense>} />



            <Route path="/investmentobjective/investment-objective" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentObjectives />
            </Suspense>} />
            <Route path="/investmentobjective/add-investment-objective" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentObjectives />
            </Suspense>} />
            <Route path="/investmentobjective/edit-investment-objective/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentObjectives />
            </Suspense>} />

            {/* Master */}

            {/* Accouting Master */}

            <Route path="/accouting-master/financial-year" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialYear />
            </Suspense>} />
            <Route path="/accouting-master/add-financial-year" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditFinancialYear />
            </Suspense>} />
            <Route path="/accouting-master/edit-financial-year/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditFinancialYear />
            </Suspense>} />
            <Route path="/master/menu-organizer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MenuOrganizer />
            </Suspense>} />
            <Route path="/master/add-menu-organizer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMenuOrganizer />
            </Suspense>} />
            <Route path="/master/edit-menu-organizer/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMenuOrganizer />
            </Suspense>} />
            <Route path="/master/archived-menu-organizer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMenuOrganizer />
            </Suspense>} />

            <Route path="/accouting-master/cost-Inflation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CostInflation />
            </Suspense>} />
            <Route path="/accouting-master/add-cost-Inflation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCostInflation />
            </Suspense>} />
            <Route path="/accouting-master/edit-cost-Inflation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCostInflation />
            </Suspense>} />
            <Route path="/accouting-master/archived-cost-Inflation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCostInflation />
            </Suspense>} />
            <Route path="/accouting-master/gst-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GstMaster />
            </Suspense>} />
            <Route path="/accouting-master/add-gst-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGstMaster />
            </Suspense>} />
            <Route path="/accouting-master/edit-gst-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGstMaster />
            </Suspense>} />
            <Route path="/accouting-master/archived-gst-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedGstMaster />
            </Suspense>} />

            {/* Cis Master  -> Newly Added Module */}

            <Route path="/master/cis-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CisMaster />
            </Suspense>} />
            <Route path="/master/add-cis-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCisMaster />
            </Suspense>} />
            <Route path="/master/edit-cis-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCisMaster />
            </Suspense>} />
            <Route path="/master/archived-cis-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCisMaster />
            </Suspense>} />

            {/* Client onboarding checklist master  -> Newly Added Module */}

            <Route path="/master/client-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-client-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-client-onboarding-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-client-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientOnboardingChecklistMaster />
            </Suspense>} />

            {/* Client Clearance ChecklistMaster */}

            <Route path="/master/client-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ClientClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-client-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddClientClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-client-clearance-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddClientClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-client-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedClientClearanceChecklistMaster />
            </Suspense>} />

            {/* Employee Onboarding Checklist Master */}

            <Route path="/master/employee-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <EmployeeOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-employee-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-employee-onboarding-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-employee-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedEmployeeOnboardingChecklistMaster />
            </Suspense>} />

            {/* Employee Clearance Checklist Master */}

            <Route path="/master/employee-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <EmployeeClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-employee-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-employee-clearance-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-employee-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedEmployeeClearanceChecklistMaster />
            </Suspense>} />

            {/* Notification Master */}

            <Route path="/master/notification-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <NotificationMaster />
            </Suspense>} />
            <Route path="/master/add-notification-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationMaster />
            </Suspense>} />
            <Route path="/master/edit-notification-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationMaster />
            </Suspense>} />
            <Route path="/master/archived-notification-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedNotificationMaster />
            </Suspense>} />

            {/* Task Master */}

            <Route path="/master/task-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <TaskMaster />
            </Suspense>} />
            <Route path="/add-task-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaskMaster />
            </Suspense>} />
            <Route path="/edit-task-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaskMaster />
            </Suspense>} />
            <Route path="/archived-task-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedTaskMaster />
            </Suspense>} />

            {/* Notification Title */}
            <Route path="/master/notification-title" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <NotificationTitle />
            </Suspense>} />
            <Route path="/master/add-notification-title" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationTitle />
            </Suspense>} />
            <Route path="/master/edit-notification-title/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationTitle />
            </Suspense>} />
            <Route path="/master/archived-notification-title" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedNotificationTitle />
            </Suspense>} />

            {/* Notification Status */}
            <Route path="/master/notification-status" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <NotificationStatus />
            </Suspense>} />
            <Route path="/master/archived-notification-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NotificationArchivedStatus />
            </Suspense>} />
            <Route path="/master/read-notification-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NotificationReadStatus />
            </Suspense>} />

            {/* Website Compliance */}
            <Route path="/master/website-compliance/investor-charter" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <InvestorCharter />
            </Suspense>} />
            <Route path="/master/website-compliance/Complaints" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <Complaints />
            </Suspense>} />
            <Route path="/Complaints-count/:month" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ComplaintsCount />
            </Suspense>} />
            <Route path="/add-complaint" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddComplaints />
            </Suspense>} />
            <Route path="/edit-complaint/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddComplaints />
            </Suspense>} />
            <Route path="/master/website-compliance/annual-compliance-audit-reports" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AnnualComplianceAuditReports />
            </Suspense>} />
            <Route path="/add-annual-compliance" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddAnnualComplianceAuditReports />
            </Suspense>} />
            <Route path="/edit-annual-compliance/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddAnnualComplianceAuditReports />
            </Suspense>} />
            <Route path="/master/website-compliance/grievance-redressal-mechanisms" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <GrievanceRedressalMechanisms />
            </Suspense>} />

            {/* Risk Profile Master */}
            <Route path="/master/risk-profile-introduction" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <RiskProfileIntroduction />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <RiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer-add" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddRiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedRiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilesTypes />
            </Suspense>} />
            <Route path="/master/risk-profile-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfiles />
            </Suspense>} />
            <Route path="/risk-profile-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilesTypesSuperAdmin />
            </Suspense>} />
            <Route path="/master/add-risk-profile-type" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddRiskProfiles />
            </Suspense>} />
            <Route path="/master/archived-risk-profile-type" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedRiskProfiles />
            </Suspense>} />
            <Route path="/master/risk-profile-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfiles />
            </Suspense>} />
            <Route path="/master/risk-profile-Q&A" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilesQA />
            </Suspense>} />
            <Route path="/master/archived-risk-profile-Q&A" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedRiskProfilesQA />
            </Suspense>} />
            <Route path="/master/add-risk-profile-Q&A" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfilesQA />
            </Suspense>} />
            <Route path="/master/edit-risk-profile-Q&A/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfilesQA />
            </Suspense>} />


            {/* Company Details */}

            <Route path="/company-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompanyMaster />
            </Suspense>} />
            <Route path="/edit-company-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyMaster />
            </Suspense>} />
            <Route path="/archived-company-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCompanyMaster />
            </Suspense>} />
            <Route path="/master/adviosr" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Advisors />
            </Suspense>} />
            <Route path="/master/archived-adviosr" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAdvisors />
            </Suspense>} />
            <Route path="/master/add-adviosr" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAdvisors />
            </Suspense>} />
            <Route path="/master/edit-adviosr/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAdvisors />
            </Suspense>} />

            {/* Assumption Master */}


            <Route path="/assumption-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssumptionMaster />
            </Suspense>} />
            <Route path="/add-assumption-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAssumptionMaster />
            </Suspense>} />
            <Route path="/edit-assumption-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAssumptionMaster />
            </Suspense>} />
            <Route path="/archived-assumption-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAssumptionMaster />
            </Suspense>} />

            {/* Role Management */}

            <Route path="/role-management" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RoleManagment />
            </Suspense>} />
            <Route path="/create-role-management" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateRoleManagement />
            </Suspense>} />
            <Route path="/edit-role-management/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateRoleManagement />
            </Suspense>} />
            <Route path="/role-management-permission" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RoleManagmentPermission />
            </Suspense>} />

            {/* Uplaod Document */}

            <Route path="/sa-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UploadDocument />
            </Suspense>} />

            {/* Operations */}


            <Route path="/operations/mftransactionsErrors/mftransactions-mising-schemes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsErrorsMissingSchemes />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/matched" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MatchedScheme />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInSfa" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMissingInSFA />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInAccord" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMIssingInAccord />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInAccordRTA" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMIssingInAccordRTA />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInAccordAMFI" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMIssingInAccordAMFI />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/isVerified" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MFSchemeIsVerified />
            </Suspense>} />
            <Route path="/operations/ShareVerification/matched" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesMatchedScheme />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missing" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissing />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missing-nse" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingNSE />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missing-isin" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingISIN />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missingInAccord" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingInAccord />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missingInSfa" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingInSFA />
            </Suspense>} />
            <Route path="/operations/ShareVerification/isVerified" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeIsVerified />
            </Suspense>} />
            <Route path="/operations/mftransactionsErrors/mftransactions-scheme-mapping" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsErrorSchemeMapping />
            </Suspense>} />
            <Route path="/operations/mftransactionsErrors/mftransactions-errors" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsErrors />
            </Suspense>} />
            <Route path="/operations/shareTransaction/sharetransaction-missing-code" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionMissingCode />
            </Suspense>} />
            <Route path="/operations/shareTransaction/sharetransaction-error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsError />
            </Suspense>} />
            <Route path="/operations/clientMigration" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientMigration />
            </Suspense>} />
            <Route path="/operations/add-clientMigration" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMigration />
            </Suspense>} />
            <Route path="/operations/mftransactionsErrors/scheme-verify" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MFSchemeVerify />
            </Suspense>} />


            {/* Mail Template */}

            <Route path="/mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MailTemplate />
            </Suspense>} />
            <Route path="/add-mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailTemplate />
            </Suspense>} />
            <Route path="/edit-mail-template/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailTemplate />
            </Suspense>} />




            <Route path="/insurance/payout-details/:id/:type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsurancePayoutDetails />
            </Suspense>} />

            {/* Financial Planning */}


            {/* financial plans */}
            <Route path="/financial-plans" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlans />
            </Suspense>} />
            <Route path="/financial-plans-bank-and-dmat" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningBankAndDMat />
            </Suspense>} />
            <Route path="/financial-plans-homePage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              {/*<FinancialPlansHomePage />*/}
              <StartPlanning />
            </Suspense>} />
            <Route path="/financial-plans-cover-page" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningCoverPage />
            </Suspense>} />
            <Route path="/financial-plans-share" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningShare />
            </Suspense>} />
            <Route path="/financial-plans-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningMutualFund />
            </Suspense>} />
            <Route path="/financial-plans-ulip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningUlip />
            </Suspense>} />
            <Route path="/financial-plans-moneyback" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningMoneyBack />
            </Suspense>} />
            <Route path="/financial-plans-fixed-income" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningFixedIncome />
            </Suspense>} />
            <Route path="/financial-plans-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningRetirementProducts />
            </Suspense>} />
            <Route path="/financial-plans-bullion" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningBullion />
            </Suspense>} />
            <Route path="/financial-plans-realestate" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningRealEstate />
            </Suspense>} />
            <Route path="/financial-planing" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FanancialPlaning />
            </Suspense>} />
            <Route path="/financial-planing/life-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LifeInsurance />
            </Suspense>} />
            <Route path="/financial-planing/retirement-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RetirementPlanning />
            </Suspense>} />
            <Route path="/financial-planing/householders-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdersInsurance />
            </Suspense>} />
            <Route path="/financial-planing/vehicle-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <VehicleInsurance />
            </Suspense>} />
            <Route path="/financial-planing/accident-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AccidentInsurance />
            </Suspense>} />
            <Route path="/financial-planing/healthcare-contingency-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HealthcareContingencyFund />
            </Suspense>} />
            <Route path="/financial-planing/contingency" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Contingency />
            </Suspense>} />
            <Route path="/financial-planing/life-insurance-expenses" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LifeInsuranceExpenses />
            </Suspense>} />
            <Route path="/financial-planing/lump-sum-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LumpSumCalculation />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanning />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-new-regime-self/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningNewRegimeSelf />
            </Suspense>} />

            <Route path="/reports/client/tax-calculation-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientTaxPlanningNewRegime />
            </Suspense>} />

            <Route path="/reports/client/tax-calculation-old-regime-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientTaxPlanningOldRegime />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-old-regime-self/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningOldRegimeSelf />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-new-regime-spouse/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningNewRegimeSpouse />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-old-regime-spouse/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningOldRegimeSpouse />
            </Suspense>} />
            <Route path="/financial-planing/asset-mapping" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetMapping />
            </Suspense>} />
            <Route path="/tax-plans" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlans />
            </Suspense>} />
            <Route path="/financial/plan/advice/request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/request-sent-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequestSentForApproval />
            </Suspense>} />
            <Route path="/financial/plan/advice/request-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequestCompleted />
            </Suspense>} />
            <Route path="/financial/plan/advice/request-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequestDeleted />
            </Suspense>} />
            <Route path="/financial/plan/advice/lumpSum/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LumpsumAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/sip-investment/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipInvestmentAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/sip-cancellation/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipCancellationAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/sip-pause/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipPauseAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/redemption/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RedemptionAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-proactive-redemption-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRedemptionAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-proactive-investment-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkInvestmentAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-bulk-investment-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkInvestmentAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-proactive-bulk-redemption-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkRedemptionAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-bulk-redemption-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkRedemptionAdviceRequestAdd />
              {/* <ProactiveBulkRedemptionAdviceRequestEdit /> */}
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-redemption-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRedemptionAdviceRequestEdit />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-cancellation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvices />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-investment-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestments />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-investment-request/:proactiveId/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestments />
              {/* <ProactiveAdvicesInvestmentsEdit /> */}
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-cancellation-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesCancellation />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemption />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesBulkRedemption />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesBulkInvestment />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentSentForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-approval-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentApprovalDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-approval-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkRedemptionApprovalDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemptionSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkAdvicesRedemptionSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkAdvicesRedemptionCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkAdvicesRedemptionDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemptionCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemptionDeleted />
            </Suspense>} />

            <Route path="/financial/plan/proactive/advice-investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestment />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-investment-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestmentSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-investment-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestmentCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-investment-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestmentDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-activesplit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesActiveSplit />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesDeleted />
            </Suspense>} />
            <Route path="/financial-planing/loans" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanLoans />
            </Suspense>} />
            <Route path="/financial-planing/insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CapitalAllocationInsurance />
            </Suspense>} />
            <Route path="/financial-planing/sip-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipCalculation />
            </Suspense>} />
            <Route path="/financial-planing/stp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalStp />
            </Suspense>} />
            <Route path="/financial-planing/swp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalSwp />
            </Suspense>} />
            <Route path="/financial-planing/goal-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalComments />
            </Suspense>} />
            <Route path="/financial-planing/investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Investment />
            </Suspense>} />
            <Route path="/financial-planing/investment-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentComments />
            </Suspense>} />
            <Route path="/financial-planing/immediate-cashflow-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImmediateCashFlowPlan />
            </Suspense>} />
            <Route path="/financial-planing/annual-spendings" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AnnualSpendings />
            </Suspense>} />
            <Route path="/financial-planing/estate-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstatePlanning />
            </Suspense>} />
            <Route path="/financial-planing/proposed-action-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProposedActionPlan />
            </Suspense>} />
            <Route path="/financial-planing/evaluation-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EvaluationReport />
            </Suspense>} />
            <Route path="/financial-planing/disclaimers-disclosurest" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DisclaimersDisclosures />
            </Suspense>} />
            <Route path="/financial-planing/signoff" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SignOff />
            </Suspense>} />
            <Route path="/financial-planing/close-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClosePlan />
            </Suspense>} />
            <Route path="/financial-planing/start-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <StartPlanning />
            </Suspense>} />
            <Route path="/financial-planing/health-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HealthInsurance />
            </Suspense>} />


            {/* Finaancial Planning Report */}

            <Route path="/financial-planing/report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningReport />
            </Suspense>} />




            {/* Client Portfolio */}

            <Route path="/financial-planing/client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FpClientPortfolio />
            </Suspense>} />
            <Route path="/financial-planing/client-portfolio-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientPortfolioPassbook />
            </Suspense>} />
            <Route path="/Corpevents/GetCorpevents" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CorporateActions />
            </Suspense>} />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
